import {
  requestApi,
  API_END_POINT,
  requestFileApi,
} from '../../common/api';
import {
  RESULT_CODE,
  CREATE_FILE_PROCESS_KBN,
  PROCESS_STATUS,
  CONDITION_RADIO,
  DISP_COUNT_LIMIT,
  GET_SAVE_FLG,
  TARGET_SEARCH_DISP_ITEM,
  LATEST_FLG,
  FUNC_TYPE,
  SEND_TYPE,
} from '../../common/const';
import config from '../../common/config';
import { getMessage } from '../../common/util';
import { ERROR, WARN } from '../../common/message';
import { setErrorMessage } from './CommonAction';

/**
 * state初期化のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_INIT_TARGET_STATE = 'TARGET/SET_INIT_TARGET_STATE';

/**
 * state初期化
 */
export const setInitTargetState = () => ({
  type: SET_INIT_TARGET_STATE,
});

/**
 * 地域リスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_AREA = 'TARGET/SET_AREA';

/**
 * 地域リスト設定
 * @param   {object}  areaList  地域リスト
 */
export const setArea = (areaList) => ({
  type: SET_AREA, areaList,
});

/**
 * 分類業種リスト(業種.大分類一覧)設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_INDUSTRY_B = 'TARGET/SET_INDUSTRY_B';

/**
 * 分類業種リスト(業種.大分類一覧)設定
 * @param   {object}  industryB  分類業種リスト(業種.大分類一覧)
 */
export const setIndustryB = (industryB) => ({
  type: SET_INDUSTRY_B, industryB,
});

/**
 * ダウンロードステータス、作成日時、処理件数、総件数設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DOWNLOAD_STATUS = 'TARGET/SET_DOWNLOAD_STATUS';

/**
 * ダウンロードステータス、作成日時、処理件数、総件数設定
 * @param   {object}  downloadStatus  ダウンロードステータス、作成日時、処理件数、総件数
 */
export const setDownloadStatus = (downloadStatus = {}) => ({
  type: SET_DOWNLOAD_STATUS, downloadStatus,
});

/**
 * ポーリングID設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_POLLING_ID = 'TARGET/SET_POLLING_ID';

/**
 * ポーリングID設定
 * @param   {number} pollingId ポーリングID
 */
export const setPollingId = (pollingId) => (
  { type: SET_POLLING_ID, pollingId }
);

/**
 * リクエストパラメータ用検索条件設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SEARCH_CONDITION = 'TARGET/SET_SEARCH_CONDITION';

/**
 * リクエストパラメータ用検索条件設定
 * @param   {object}  searchCondition  リクエストパラメータ用検索条件
 */
export const setSearchCondition = (searchCondition) => ({
  type: SET_SEARCH_CONDITION, searchCondition,
});

/**
 * リストタブ表示用検索条件設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DISP_SEARCH_CONDITION = 'TARGET/SET_DISP_SEARCH_CONDITION';

/**
 * リストタブ表示用検索条件設定
 * @param {object} dispSearchCondition リストタブ表示用検索条件設定
 */
export const setDispSearchCondition = (dispSearchCondition) => ({
  type: SET_DISP_SEARCH_CONDITION, dispSearchCondition,
});

/**
 * 画面表示検索条件更新のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_UPDATE_TARGETING_CRITERIA = 'TARGET/SET_UPDATE_TARGETING_CRITERIA';

/**
 * 画面表示検索条件更新
 *  @param   {object}  targetingCriteria
 */
export const setUpdateTargetingCriteria = (targetingCriteria) => ({
  type: SET_UPDATE_TARGETING_CRITERIA,
  // 検索対象
  searchTarget: targetingCriteria.searchTarget,
  // 所在地追加済み条件
  addressCondition: targetingCriteria.addressCondition,
  // 業種追加済み条件
  industryCondition: targetingCriteria.industryCondition,
  // 扱い品追加済み条件
  productsCondition: targetingCriteria.productsCondition,
  // 主業種フラグ
  mainIndustryFlg: targetingCriteria.mainIndustryFlg,
  // 取引条件項目
  tradeInfoSearchItem: targetingCriteria.tradeInfoSearchItem,
  // 取引情報追加済み条件
  tradeInfoCondition: targetingCriteria.tradeInfoCondition,
  // 最新決済月
  accountMonth: targetingCriteria.accountMonth,
  // 資本金
  capitalFrom: targetingCriteria.capitalFrom,
  capitalTo: targetingCriteria.capitalTo,
  // 当期売上高
  salesFrom: targetingCriteria.salesFrom,
  salesTo: targetingCriteria.salesTo,
  // 当期売上伸長率
  salesRateFrom: targetingCriteria.salesRateFrom,
  salesRateTo: targetingCriteria.salesRateTo,
  // 当期利益金
  benefitFrom: targetingCriteria.benefitFrom,
  benefitTo: targetingCriteria.benefitTo,
  // 当期利益伸長率
  benefitRateFrom: targetingCriteria.benefitRateFrom,
  benefitRateTo: targetingCriteria.benefitRateTo,
  // 従業員数
  employeeFrom: targetingCriteria.employeeFrom,
  employeeTo: targetingCriteria.employeeTo,
  // 国内最上位親会社DUNS
  topDuns: targetingCriteria.topDuns,
  // 国内最上位親会社TSRコード
  topTsrCode: targetingCriteria.topTsrCode,
  // 評点
  scoreFrom: targetingCriteria.scoreFrom,
  scoreTo: targetingCriteria.scoreTo,
  // 事業所数
  officeCountFrom: targetingCriteria.officeCountFrom,
  officeCountTo: targetingCriteria.officeCountTo,
  // 代表者
  repLastName: targetingCriteria.repLastName,
  repFirstName: targetingCriteria.repFirstName,
  // 取引情報有無
  additionalitem: targetingCriteria.additionalitem,
  // 取引情報検索フラグ1
  tradesearchflag1: targetingCriteria.tradesearchflag1,
  // 取引情報検索フラグ2
  tradesearchflag2: targetingCriteria.tradesearchflag2,
  // 表示用資本金(3桁カンマ)
  dispCapitalFrom: targetingCriteria.dispCapitalFrom,
  dispCapitalTo: targetingCriteria.dispCapitalTo,
  // 表示用売上高(3桁カンマ)
  dispSalesFrom: targetingCriteria.dispSalesFrom,
  dispSalesTo: targetingCriteria.dispSalesTo,
  // 表示用売上高伸長率(3桁カンマ)
  dispSalesRateFrom: targetingCriteria.dispSalesRateFrom,
  dispSalesRateTo: targetingCriteria.dispSalesRateTo,
  // 表示用利益金(3桁カンマ)
  dispBenefitFrom: targetingCriteria.dispBenefitFrom,
  dispBenefitTo: targetingCriteria.dispBenefitTo,
  // 表示用利益金伸長率(3桁カンマ)
  dispBenefitRateFrom: targetingCriteria.dispBenefitRateFrom,
  dispBenefitRateTo: targetingCriteria.dispBenefitRateTo,
  // 表示用従業員数(3桁カンマ)
  dispEmployeesFrom: targetingCriteria.dispEmployeesFrom,
  dispEmployeesTo: targetingCriteria.dispEmployeesTo,
  // 表示用事業所数(3桁カンマ)
  dispOfficeCountFrom: targetingCriteria.dispOfficeCountFrom,
  dispOfficeCountTo: targetingCriteria.dispOfficeCountTo,
  // 事業所区分リスト
  jgkbList: targetingCriteria.jgkbList,

  // 上場市場リスト
  marketSegment: targetingCriteria.marketSegment,
  // 商号漢字
  sgkn: targetingCriteria.sgkn,
  // 商号漢字検索タイプ区分
  sgknSearchType: targetingCriteria.sgknSearchType,
  // 設立年FROM
  startYearFrom: targetingCriteria.startYearFrom,
  // 設立月FROM
  startMonthFrom: targetingCriteria.startMonthFrom,
  // 設立年TO
  startYearTo: targetingCriteria.startYearTo,
  // 設立月TO
  startMonthTo: targetingCriteria.startMonthTo,
  // 概況
  syrkGkny: targetingCriteria.syrkGkny,
  // 販売先
  customerCompanyCondition: targetingCriteria.hnbsk_list,
  // 仕入先
  supplierCompanyCondition: targetingCriteria.srsk_list,
  // 国内最上位親会社
  topCompanyCondition: targetingCriteria.series_top_tsr_code_list,
  // 格付け
  classificationList: targetingCriteria.classificationList,
  // 最新期フラグ
  latestFlg: targetingCriteria.latestFlg,
});

/**
 * 画面表示検索条件設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SAVE_CONDITION = 'TARGET/SET_SAVE_CONDITION';

/**
 * 画面表示検索条件設定
 * @param   {object}  saveCondition
 */
export const setSaveCondition = (saveCondition) => ({
  type: SET_SAVE_CONDITION, saveCondition,
});

/**
 * 企業情報一覧、結果件数、全体件数設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_COMPANY_SEARCH_LIST = 'TARGET/SET_COMPANY_SEARCH_LIST';

/**
 * 企業情報一覧、結果件数、全体件数設定
 * @param   {object}  companySearchList  企業情報一覧、結果件数、全体件数
 */
export const setCompanySearchList = (companySearchList) => ({
  type: SET_COMPANY_SEARCH_LIST, companySearchList,
});

/**
 * ターゲティング画面項目検索設定リスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TARGETING_DISP_ITEMS = 'TARGET/SET_TARGETING_DISP_ITEMS';

/**
 * ターゲティング画面項目検索設定リスト設定
 * @param   {object}  targetingDispItems
 */
export const setTargetingDispItems = (targetingDispItems) => ({
  type: SET_TARGETING_DISP_ITEMS, targetingDispItems,
});

/**
 * 所在地条件設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ADDRESS_CONDITION = 'TARGET/SET_ADDRESS_CONDITION';

/**
 * 所在地条件設定
 * @param   {object}  addressCondition  所在地条件
 */
export const setAddressCondition = (addressCondition) => ({
  type: SET_ADDRESS_CONDITION, addressCondition,
});

/**
 * 所在地取得フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_GET_ADDRESS_FLG = 'TARGET/SET_GET_ADDRESS_FLG';
/**
 * 所在地取得フラグ設定
 * @param   {string}  getAddressFlg
 */
export const setGetAddressFlg = (getAddressFlg) => ({
  type: SET_GET_ADDRESS_FLG, getAddressFlg,
});

/**
 * 商号漢字設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SGKN = 'TARGET/SET_SGKN';

/**
 * 商号漢字設定
 * @param   {string}  sgkn
 */
export const setSgkn = (sgkn) => ({
  type: SET_SGKN, sgkn,
});

/**
 * 商号漢字検索タイプ区分設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SGKN_SEARCH_TYPE = 'TARGET/SET_SGKN_SEARCH_TYPE';

/**
 * 商号漢字検索タイプ区分設定
 * @param   {string}  sgknSearchType
 */
export const setSgknSearchType = (sgknSearchType) => ({
  type: SET_SGKN_SEARCH_TYPE, sgknSearchType,
});

/**
 * 分類業種リスト(業種.中分類一覧)設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_INDUSTRY_N = 'TARGET/SET_INDUSTRY_N';

/**
 * 分類業種リスト(業種.中分類一覧)設定
 * @param   {object}  industryN  分類業種リスト(業種.中分類一覧)
 */
export const setIndustryN = (industryN) => ({
  type: SET_INDUSTRY_N, industryN,
});

/**
 * 分類業種リスト(業種.小分類一覧)設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_INDUSTRY_S = 'TARGET/SET_INDUSTRY_S';

/**
 * 分類業種リスト(業種.小分類一覧)設定
 * @param   {object}  industryS  分類業種リスト(業種.小分類一覧)
 */
export const setIndustryS = (industryS) => ({
  type: SET_INDUSTRY_S, industryS,
});

/**
 * 分類業種リスト(業種.細分類一覧)設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_INDUSTRY_M = 'TARGET/SET_INDUSTRY_M';

/**
 * 分類業種リスト(業種.細分類一覧)設定
 * @param   {object}  industryM  分類業種リスト(業種.細分類一覧)
 */
export const setIndustryM = (industryM) => ({
  type: SET_INDUSTRY_M, industryM,
});

/**
 * 業種条件設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_INDUSTRY_CONDITION = 'TARGET/SET_INDUSTRY_CONDITION';

/**
 * 業種条件設定
 * @param   {object}  industryCondition  業種条件
 */
export const setIndustryCondition = (industryCondition) => ({
  type: SET_INDUSTRY_CONDITION, industryCondition,
});

/**
 *業種キーワード検索結果設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_INDUSTRY_RESULT = 'TARGET/SET_INDUSTRY_RESULT';

/**
 * 業種キーワード検索結果設定
 * @param   {object}  industryResult  業種条件
 */
export const setIndustryResult = (industryResult) => ({
  type: SET_INDUSTRY_RESULT, industryResult,
});

/**
 * 業種条件選択内容追加設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_INDUSTRY_ADD_CONDITION = 'TARGET/SET_INDUSTRY_ADD_CONDITION';

/**
 * 業種条件選択内容追加設定
 * @param   {object}  industryAddCondition  業種条件選択内容
 */
export const setIndustryAddCondition = (industryAddCondition) => ({
  type: SET_INDUSTRY_ADD_CONDITION, industryAddCondition,
});

/**
 * 業種条件選択内容表示用のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_INDUSTRY_DISPLAY_CONDITION = 'TARGET/SET_INDUSTRY_DISPLAY_CONDITION';

/**
 * 業種条件選択内容表示用
 * @param   {object}  industryDisplayCondition  業種条件表示用
 */
export const setIndustryDisplayCondition = (industryDisplayCondition) => ({
  type: SET_INDUSTRY_DISPLAY_CONDITION, industryDisplayCondition,
});

/**
 * 業種取得フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */

export const SET_GET_INDUSTRY_FLG = 'TARGET/SET_GET_INDUSTRY_FLG';
/**
 * 業種取得フラグ設定
 * @param   {string}  getIndustryFlg
 */
export const setGetIndustryFlg = (getIndustryFlg) => ({
  type: SET_GET_INDUSTRY_FLG, getIndustryFlg,
});

/**
 * 扱い品条件選択内容表示用のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_PRODUCT_DISPLAY_CONDITION = 'TARGET/SET_PRODUCT_DISPLAY_CONDITION';

/**
 * 業種条件選択内容表示用
 * @param   {object}  productDisplayCondition  扱い品条件表示用
 */
export const setProductDisplayCondition = (productDisplayCondition) => ({
  type: SET_PRODUCT_DISPLAY_CONDITION, productDisplayCondition,
});

/**
 * 扱い品条件設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_PRODUCTS_CONDITION = 'TARGET/SET_PRODUCTS_CONDITION';

/**
 * 扱い品条件設定
 * @param   {object}  productsCondition  扱い品条件
 */
export const setProductsCondition = (productsCondition) => ({
  type: SET_PRODUCTS_CONDITION, productsCondition,
});

/**
 * 主業種フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_MAIN_INDUSTRY_FLG = 'TARGET/SET_MAIN_INDUSTRY_FLG';

/**
 * 主業種フラグ設定
 * @param   {string}  mainIndustryFlg  主業種フラグ
 */
export const setMainIndustryFlg = (mainIndustryFlg) => ({
  type: SET_MAIN_INDUSTRY_FLG, mainIndustryFlg,
});

/**
 * 検索条件保存ポップアップのON、OFFのフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SAVE_CONDITON_POP_FLG = 'TARGET/SET_SAVE_CONDITON_POP_FLG';

/**
 * 検索条件保存ポップアップのON、OFFのフラグ設定
 * @param   {boolean}  saveConditionPopFlg  検索条件保存ポップアップのON、OFFのフラグ
 */
export const setSaveConditionPopFlg = (saveConditionPopFlg) => ({
  type: SET_SAVE_CONDITON_POP_FLG, saveConditionPopFlg,
});

/**
 * 検索条件保存成功ポップアップのON、OFFのフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SAVE_CONDITON_SUCCESS_POP_FLG = 'TARGET/SET_SAVE_CONDITON_SUCCESS_POP_FLG';

/**
 * 検索条件保存成功ポップアップのON、OFFのフラグ設定
 * @param   {boolean}  saveConditionSuccessPopFlg  検索条件保存成功ポップアップのON、OFFのフラグ
 */
export const setSaveConditionSuccessPopFlg = (saveConditionSuccessPopFlg) => ({
  type: SET_SAVE_CONDITON_SUCCESS_POP_FLG, saveConditionSuccessPopFlg,
});

/**
 * 検索条件一覧ポップアップのON、OFFのフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SEARCH_CONDITON_POP_FLG = 'TARGET/SET_SEARCH_CONDITON_POP_FLG';

/**
 * 検索条件一覧ポップアップのON、OFFのフラグ設定
 * @param   {boolean}  searchConditionPopFlg  検索条件一覧ポップアップのON、OFFのフラグ
 */
export const setSearchConditionPopFlg = (searchConditionPopFlg) => ({
  type: SET_SEARCH_CONDITON_POP_FLG, searchConditionPopFlg,
});

/**
 * 検索条件選択フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SELECT_CONDITION_FLG = 'TARGET/SET_SELECT_CONDITION_FLG';

/**
 * 検索条件選択フラグ設定
 * @param   {boolean}  selectConditionFlg
 */
export const setSelectConditionFlg = (selectConditionFlg) => ({
  type: SET_SELECT_CONDITION_FLG, selectConditionFlg,
});

/**
 * シーケンスID（検索条件一覧ポップアップ）のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SEARCH_CONDITON_SEQ_ID = 'TARGET/SET_SEARCH_CONDITON_SEQ_ID';

/**
 * シーケンスID（検索条件一覧ポップアップ）設定
 * @param   {string}  searchConditionSeqId  検索条件一覧ポップアップのシーケンスID
 */
export const setSearchConditionSeqId = (searchConditionSeqId) => ({
  type: SET_SEARCH_CONDITON_SEQ_ID, searchConditionSeqId,
});

/**
 * 検索条件一覧エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_SEARCH_CONDITION_POP = 'TARGET/SET_ERR_MSG_SEARCH_CONDITION_POP';

/**
  * 検索条件一覧エラーメッセージ設定
  * @param   {string}  errMsgSearchConditionPop
  */
export const setErrMsgSearchConditionPop = (errMsgSearchConditionPop) => ({
  type: SET_ERR_MSG_SEARCH_CONDITION_POP, errMsgSearchConditionPop,
});

/**
 * 検索条件削除確認ポップアップのON、OFFのフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SEARCH_CONDITON_DELETE_POP_FLG = 'TARGET/SET_SEARCH_CONDITON_DELETE_POP_FLG';

/**
 * 検索条件削除確認ポップアップのON、OFFのフラグ設定
 * @param   {boolean}  searchConditionDeletePopFlg  検索条件削除確認ポップアップのON、OFFのフラグ
 */
export const setSearchConditionDeletePopFlg = (searchConditionDeletePopFlg) => ({
  type: SET_SEARCH_CONDITON_DELETE_POP_FLG, searchConditionDeletePopFlg,
});

/**
 * マスタ存在アラートポップアップのON、OFFのフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ALERT_MASTER_POP_FLG = 'TARGET/SET_ALERT_MASTER_POP_FLG';

/**
 * マスタ存在アラートポップアップのON、OFFのフラグ設定
 * @param   {boolean}  alertMasterPopFlg  マスタ存在アラートポップアップのON、OFFのフラグ
 */
export const setAlertMasterPopFlg = (alertMasterPopFlg) => ({
  type: SET_ALERT_MASTER_POP_FLG, alertMasterPopFlg,
});

/**
 * 画面表示用アラート項目設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ALERT_ITEM = 'TARGET/SET_ALERT_ITEM';

/**
  * 画面表示用アラート項目リスト設定
  * @param   {string}  alertItem
  */
export const setAlertItem = (alertItem) => ({
  type: SET_ALERT_ITEM, alertItem,
});

/**
 * 検索条件名設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CONDITION_NAME = 'TARGET/SET_CONDITION_NAME';

/**
 * 検索条件名設定
 * @param   {object}  conditionName  検索条件名
 */
export const setConditionName = (conditionName) => ({
  type: SET_CONDITION_NAME, conditionName,
});

/**
 * 検索条件名（吹き出し表示用）設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DISP_CONDITION_NAME = 'TARGET/SET_DISP_CONDITION_NAME';

/**
 * 検索条件名（吹き出し表示用）設定
 * @param   {object}  dispConditionName  検索条件名
 */
export const setDispConditionName = (dispConditionName) => ({
  type: SET_DISP_CONDITION_NAME, dispConditionName,
});

/**
 * 検索条件名エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_CONDITION_NAME = 'TARGET/SET_ERR_MSG_CONDITION_NAME';

/**
  * 検索条件名エラーメッセージ設定
  * @param   {string}  errMsgConditionName
  */
export const setErrMsgConditionName = (errMsgConditionName) => ({
  type: SET_ERR_MSG_CONDITION_NAME, errMsgConditionName,
});

/**
 * 検索条件名エラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_CONDITION_NAME = 'TARGET/SET_CHECK_CONDITION_NAME';

/**
  * 検索条件名エラーフラグ設定
  * @param   {boolean}  checkConditionName
  */
export const setCheckConditionName = (checkConditionName) => ({
  type: SET_CHECK_CONDITION_NAME, checkConditionName,
});

/**
 * 所在地条件ポップアップのON、OFFのフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ADDRESS_POP_FLG = 'TARGET/SET_ADDRESS_POP_FLG';

/**
 * 所在地条件ポップアップのON、OFFのフラグ設定
 * @param   {boolean}  addressPopFlg  所在地条件ポップアップのON、OFFのフラグ
 */
export const setAddressPopFlg = (addressPopFlg) => ({
  type: SET_ADDRESS_POP_FLG, addressPopFlg,
});

/**
 * 業種選択ポップアップのON、OFFのフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_INDUSTRY_POP_FLG = 'TARGET/SET_INDUSTRY_POP_FLG';

/**
 * 業種選択ポップアップのON、OFFのフラグ設定
 * @param   {boolean}  industryPopFlg  業種選択ポップアップのON、OFFのフラグ
 */
export const setIndustryPopFlg = (industryPopFlg) => ({
  type: SET_INDUSTRY_POP_FLG, industryPopFlg,
});

/**
 * 扱い品選択ポップアップのON、OFFのフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_PRODUCTS_POP_FLG = 'TARGET/SET_PRODUCTS_POP_FLG';

/**
 * 扱い品選択ポップアップのON、OFFのフラグ設定
 * @param   {boolean}  productsPopFlg  扱い品選択ポップアップのON、OFFのフラグ
 */
export const setProductsPopFlg = (productsPopFlg) => ({
  type: SET_PRODUCTS_POP_FLG, productsPopFlg,
});

/**
 * 扱い品キーワード設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */

export const SET_PRODUCT_SEARCH_CONDITION = 'TARGET/SET_PRODUCT_SEARCH_CONDITION';

/**
 * 扱い品キーワード設定
 * @param   {object}  searchCondition  リクエストパラメータ用検索条件
 */
export const setProductSearchCondition = (searchProductCondition) => ({
  type: SET_PRODUCT_SEARCH_CONDITION, searchProductCondition,
});

/**
 * 業態リスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_BUSINESS_TYPE = 'TARGE/SET_BUSINESS_TYPE';

/**
 * 業態リスト設定
 * @param    {object}  setBusinessType 業態リストの選択コードリスト
 */
export const setBusinessType = (businessType) => ({
  type: SET_BUSINESS_TYPE, businessType,
});

/**
 * 企業選択ポップアップのON、OFFのフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_COMPANY_POP_FLG = 'TARGET/SET_COMPANY_POP_FLG';

/**
 * 企業選択ポップアップのON、OFFのフラグ設定
 * @param   {boolean}  companyPopFlg  企業選択ポップアップのON、OFFのフラグ
 */
export const setCompanyPopFlg = (companyPopFlg) => ({
  type: SET_COMPANY_POP_FLG, companyPopFlg,
});

/**
 * 企業選択ポップアップのボタンのAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_COMPANY_POP_BTN = 'TARGET/SET_COMPANY_POP_BTN';

/**
 * 企業選択ポップアップのボタン設定
 * @param   {boolean}  companyPopBtn  企業選択ポップアップのボタン設定
 */
export const setCompanyPopBtn = (companyPopBtn) => ({
  type: SET_COMPANY_POP_BTN, companyPopBtn,
});

/**
 * 検索条件一覧設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SEARCH_CONDITION_LIST = 'TARGET/SET_SEARCH_CONDITION_LIST';

/**
 * 検索条件一覧設定
 * @param   {object}  searchConditionList  検索条件一覧
 */
export const setSearchConditionList = (searchConditionList) => ({
  type: SET_SEARCH_CONDITION_LIST, searchConditionList,
});

/**
 * コードマスタ取得
 * @param   {string}  shubetsuCode 種別コード
 * @returns {object}  コードマスタ
 */
export const getGyotaiMaster = (shubetsuCode) => async (dispatch) => {
  // リクエストパラメータ設定
  // リクエストパラメータ生成
  const o = {
    shbtcd: shubetsuCode,
  };
  // コードマスタ取得APIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.GET_GYOTAI_LIST, o);
  // ネットワークエラーの場合
  if (ret.result === RESULT_CODE.ANOMALY) {
    dispatch(setErrorMessage(ERROR.E09013));
  }
  return ret.response;
};

/**
 * 扱い品一覧設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_PRODUCT_RESULT_LIST = 'TARGET/SET_PRODUCT_RESULT_LIST';

/**
 * 扱い品一覧設定
 * @param   {object} productResultList 企業検索結果一覧
 */
export const setProductResultList = (productResultList = {}) => (
  { type: SET_PRODUCT_RESULT_LIST, productResultList }
);

/**
 * 扱い品一覧取得
 * @param   {string} searchWord 検索キーワード
 * @param   {string} selectBusinessType 業態コード
 * @returns boolean
 */
export const searchProductList = (searchWord, selectBusinessType) => async (dispatch) => {
  const o = {};
  o.keyword = searchWord;
  o.gyotai_code = selectBusinessType;

  const ret = await requestApi(dispatch, API_END_POINT.SEARCH_ATSUKAIHIN, o);

  // 取得件数0件の場合、一覧を空にする
  if (ret.result === RESULT_CODE.NOT_FOUND) {
    dispatch(setProductResultList());
    return true;
  }
  // エラーの場合、メッセージを設定し一覧を空にする
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setProductResultList());
    return false;
  }
  // 検索結果を一時保存領域へ保存
  dispatch(setProductResultList(ret.response));
  return true;
};

/**
 * 業態選択値リスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SELECT_BUSINESS_TYPE = 'TARGET/SET_SELECT_BUSINESS_TYPE';

/**
 * 業態選択値リスト設定
 * @param    {Array}  selectBusinessType 大業態選択値リスト
 */
export const setSelectBusinessType = (selectBusinessType = []) => ({
  type: SET_SELECT_BUSINESS_TYPE, selectBusinessType,
});

/**
 * 扱い品条件選択内容追加設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_PRODUCT_ADD_CONDITION = 'TARGET/SET_PRODUCT_ADD_CONDITION';

/**
 * 扱い品条件選択内容設定
 * @param   {object}  industryAddCondition  扱い品条件選択内容
 */
export const setProductAddCondition = (productAddCondition) => ({
  type: SET_PRODUCT_ADD_CONDITION, productAddCondition,
});

/**
 * 扱い品選択内容重複エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_PRODUCT_DUPLICATE = 'TARGET/SET_ERR_MSG_PRODUCT_DUPLICATE';

/**
  * 扱い品選択内容重複エラーメッセージ設定
  * @param   {string}  errMsgProductDuplicate
  */
export const setErrMsgProductDuplicate = (errMsgProductDuplicate) => ({
  type: SET_ERR_MSG_PRODUCT_DUPLICATE, errMsgProductDuplicate,
});

/**
 * 扱い品キーワードエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_PRODUCT_KEYWORD = 'TARGET/SET_ERR_MSG_PRODUCT_KEYWORD';

/**
  * 扱い品キーワードエラーメッセージ設定
  * @param   {string}  errMsgProductKeyword
  */
export const setErrMsgProductKeyword = (errMsgProductKeyword) => ({
  type: SET_ERR_MSG_PRODUCT_KEYWORD, errMsgProductKeyword,
});

/**
 * 扱い品キーワードエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_PRODUCT_KEYWORD = 'TARGET/SET_CHECK_PRODUCT_KEYWORD';

/**
  * 扱い品キーワードエラーフラグ設定
  * @param   {boolean}  checkProductKeyword
  */
export const setCheckProductKeyword = (checkProductKeyword) => ({
  type: SET_CHECK_PRODUCT_KEYWORD, checkProductKeyword,
});

/**
 * 扱い品取得フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_GET_PRODUCT_FLG = 'TARGET/SET_GET_PRODUCT_FLG';
/**
 * 扱い品取得フラグ設定
 * @param   {string}  getProductFlg
 */
export const setGetProductFlg = (getProductFlg) => ({
  type: SET_GET_PRODUCT_FLG, getProductFlg,
});

/**
 * 取引情報条件ポップアップのON、OFFのフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ADDITIONAL_ITEM_POP_FLG = 'TARGET/SET_ADDITIONAL_ITEM_POP_FLG';

/**
 * 取引情報条件ポップアップのON、OFFのフラグ設定
 * @param   {boolean}  additionalItemPopFlg  取引情報条件ポップアップのON、OFFのフラグ
 */
export const setAdditionalItemPopFlg = (additionalItemPopFlg) => ({
  type: SET_ADDITIONAL_ITEM_POP_FLG, additionalItemPopFlg,
});

/**
 * ダウンロードリクエストポップアップのON、OFFのフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DOWNLOAD_REQUEST_POP_FLG = 'TARGET/SET_DOWNLOAD_REQUEST_POP_FLG';

/**
 * ダウンロードリクエストポップアップのON、OFFのフラグ設定
 * @param   {boolean} downloadRequestPopFlg  ダウンロードリクエストポップアップのON、OFFのフラグ
 * @param   {boolean} downloadLimitOverFlg ダウンロード件数超過確認フラグ
 * @param   {string}  downloadLimitOverMessage ダウンロード件数超過確認メッセージ
 */
export const setDownloadRequestPopFlg = (
  downloadRequestPopFlg,
  downloadLimitOverFlg = false,
  downloadLimitOverMessage = null,
) => ({
  type: SET_DOWNLOAD_REQUEST_POP_FLG,
  downloadRequestPopFlg,
  downloadLimitOverFlg,
  downloadLimitOverMessage,
});

/**
 * タブtype設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TAB = 'TARGET/SET_TAB';

/**
 * タブtype設定
 * @param   {string}  tab  タブtype
 */
export const setTab = (tab) => ({ type: SET_TAB, tab });

/**
 * ダウンロード条件（ダウンロード項目）の選択値設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DOWNLOAD_CONFIG = 'TARGET/SET_DOWNLOAD_CONFIG';

/**
 * ダウンロード条件（ダウンロードする項目）の選択値設定
 * @param   {string}  downloadConfig  ダウンロード条件（ダウンロードする項目）の選択値
 */
export const setDownloadConfig = (downloadConfig) => ({
  type: SET_DOWNLOAD_CONFIG, downloadConfig,
});

/**
 * 検索対象設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SEARCH_TARGET = 'TARGET/SET_SEARCH_TARGET';

/**
 * 検索対象設定
 * @param   {string}  searchTarget  検索対象
 */
export const setSearchTarget = (searchTarget) => ({
  type: SET_SEARCH_TARGET, searchTarget,
});

/**
 * 最新決算月設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ACCOUNT_MONTH = 'TARGET/SET_ACCOUNT_MONTH';

/**
 * 最新決算月設定
 * @param   {string}  accountMonth  最新決算月
 */
export const setAccountMonth = (accountMonth = []) => ({
  type: SET_ACCOUNT_MONTH, accountMonth,
});

/**
 * 資本金FROM設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CAPITAL_FROM = 'TARGET/SET_CAPITAL_FROM';

/**
  * 資本金FROM設定
  * @param   {string}  capitalFrom  資本金FROM
  */
export const setCapitalFrom = (capitalFrom) => ({
  type: SET_CAPITAL_FROM, capitalFrom,
});

/**
  * 資本金TO設定のAction識別文字列
  * @type    {string}  Action識別文字列
  */
export const SET_CAPITAL_TO = 'TARGET/SET_CAPITAL_TO';

/**
  * 資本金TO設定
  * @param   {string}  capitalTo  資本金TO
  */
export const setCapitalTo = (capitalTo) => ({
  type: SET_CAPITAL_TO, capitalTo,
});

/**
 * 売上高FROM設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SALES_FROM = 'TARGET/SET_SALES_FROM';

/**
 * 売上高FROM設定
 * @param   {string}  salesFrom  売上高FROM
 */
export const setSalesFrom = (salesFrom) => ({
  type: SET_SALES_FROM, salesFrom,
});

/**
 * 売上高TO設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SALES_TO = 'TARGET/SET_SALES_TO';

/**
 * 売上高TO設定
 * @param   {string}  salesTo  売上高TO
 */
export const setSalesTo = (salesTo) => ({
  type: SET_SALES_TO, salesTo,
});

/**
 * 決算情報最新期フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_LATEST_FLG = 'TARGET/SET_LATEST_FLG';

/**
 * 決算情報最新期フラグ設定
 * @param   {string}  latestFlg  決算情報最新期フラグ
 */
export const setLatestFlg = (latestFlg) => ({
  type: SET_LATEST_FLG, latestFlg,
});

/**
 * 売上高伸長率FROM設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SALES_RATE_FROM = 'TARGET/SET_SALES_RATE_FROM';

/**
 * 売上高伸長率FROM設定
 * @param   {string}  salesRateFrom  売上高伸長率FROM
 */
export const setSalesRateFrom = (salesRateFrom) => ({
  type: SET_SALES_RATE_FROM, salesRateFrom,
});

/**
 * 売上高伸長率TO設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SALES_RATE_TO = 'TARGET/SET_SALES_RATE_TO';

/**
 * 売上高伸長率TO設定
 * @param   {string}  salesRateTo  売上高伸長率TO
 */
export const setSalesRateTo = (salesRateTo) => ({
  type: SET_SALES_RATE_TO, salesRateTo,
});

/**
 * 利益金FROM設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_BENEFIT_FROM = 'TARGET/SET_BENEFIT_FROM';

/**
  * 利益金FROM設定
  * @param   {string}  benefitFrom  利益金FROM
  */
export const setBenefitFrom = (benefitFrom) => ({
  type: SET_BENEFIT_FROM, benefitFrom,
});

/**
  * 利益金TO設定のAction識別文字列
  * @type    {string}  Action識別文字列
  */
export const SET_BENEFIT_TO = 'TARGET/SET_BENEFIT_TO';

/**
  * 利益金TO設定
  * @param   {string}  benefitTo  利益金TO
  */
export const setBenefitTo = (benefitTo) => ({
  type: SET_BENEFIT_TO, benefitTo,
});

/**
  * 利益金伸長率FROM設定のAction識別文字列
  * @type    {string}  Action識別文字列
  */
export const SET_BENEFIT_RATE_FROM = 'TARGET/SET_BENEFIT_RATE_FROM';

/**
  * 利益金伸長率FROM設定
  * @param   {string}  benefitRateFrom  利益金伸長率FROM
  */
export const setBenefitRateFrom = (benefitRateFrom) => ({
  type: SET_BENEFIT_RATE_FROM, benefitRateFrom,
});

/**
  * 利益金伸長率TO設定のAction識別文字列
  * @type    {string}  Action識別文字列
  */
export const SET_BENEFIT_RATE_TO = 'TARGET/SET_BENEFIT_RATE_TO';

/**
  * 利益金伸長率TO設定
  * @param   {string}  benefitRateTo  利益金伸長率TO
  */
export const setBenefitRateTo = (benefitRateTo) => ({
  type: SET_BENEFIT_RATE_TO, benefitRateTo,
});

/**
 * 従業員数FROM設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_EMPLOYEE_FROM = 'TARGET/SET_EMPLOYEE_FROM';

/**
 * 従業員数FROM設定
 * @param   {string}  employeeFrom  従業員数FROM
 */
export const setEmployeeFrom = (employeeFrom) => ({
  type: SET_EMPLOYEE_FROM, employeeFrom,
});

/**
 * 従業員数TO設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_EMPLOYEE_TO = 'TARGET/SET_EMPLOYEE_TO';

/**
 * 従業員数TO設定
 * @param   {string}  employeeTo  従業員数TO
 */
export const setEmployeeTo = (employeeTo) => ({
  type: SET_EMPLOYEE_TO, employeeTo,
});

/**
 * 設立年FROM設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_START_YEAR_FROM = 'TARGET/SET_START_YEAR_FROM';

/**
 * 設立年FROM設定
 * @param   {string}  startYearFrom
 */
export const setStartYearFrom = (startYearFrom) => ({
  type: SET_START_YEAR_FROM, startYearFrom,
});

/**
 * 設立月FROM設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_START_MONTH_FROM = 'TARGET/SET_START_MONTH_FROM';

/**
 * 設立月FROM設定
 * @param   {string}  startMonthFrom
 */
export const setStartMonthFrom = (startMonthFrom) => ({
  type: SET_START_MONTH_FROM, startMonthFrom,
});

/**
 * 設立年TO設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_START_YEAR_TO = 'TARGET/SET_START_YEAR_TO';

/**
 * 設立年TO設定
 * @param   {string}  startYearTo
 */
export const setStartYearTo = (startYearTo) => ({
  type: SET_START_YEAR_TO, startYearTo,
});

/**
 * 設立月TO設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_START_MONTH_TO = 'TARGET/SET_START_MONTH_TO';

/**
 * 設立月TO設定
 * @param   {string}  startMonthTo
 */
export const setStartMonthTo = (startMonthTo) => ({
  type: SET_START_MONTH_TO, startMonthTo,
});

/**
 * 上場市場設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_MARKET_SEGMENT = 'TARGET/SET_MARKET_SEGMENT';

/**
 * 上場市場設定
 * @param   {string}  marketSegment  上場市場
 */
export const setMarketSegment = (marketSegment = []) => ({
  type: SET_MARKET_SEGMENT, marketSegment,
});

/**
 * 上場市場リスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_MARKET_SEGMENT_LIST = 'TARGET/SET_MARKET_SEGMENT_LIST';

/**
 * 上場市場リスト設定
 * @param   {string}  marketSegmentList
 */
export const setMarketSegmentList = (marketSegmentList = []) => ({
  type: SET_MARKET_SEGMENT_LIST, marketSegmentList,
});

/**
 * 概況設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SYRK_GKNY = 'TARGET/SET_SYRK_GKNY';

/**
 * 概況設定
 * @param   {string}  syrkGkny
 */
export const setSyrkGkny = (syrkGkny) => ({
  type: SET_SYRK_GKNY, syrkGkny,
});

/**
 * 国内最上位親会社DUNS設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TOP_DUNS = 'TARGET/SET_TOP_DUNS';

/**
 * 国内最上位親会社DUNS設定
 * @param   {string}  topDuns  国内最上位親会社DUNS
 */
export const setTopDuns = (topDuns) => ({
  type: SET_TOP_DUNS, topDuns,
});

/**
 * 評点(Slider)設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SCORE_SLIDER = 'TARGET/SET_SCORE_SLIDER';

/**
 * 評点(Slider)設定
 * @param   {object}  scoreSlider
 */
export const setScoreSlider = (scoreSlider) => ({
  type: SET_SCORE_SLIDER, scoreSlider,
});

/**
 * 評点FROM設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SCORE_FROM = 'TARGET/SET_SCORE_FROM';

/**
 * 評点FROM設定
 * @param   {string}  scoreFrom  評点FROM
 */
export const setScoreFrom = (scoreFrom) => ({
  type: SET_SCORE_FROM, scoreFrom,
});

/**
 * 評点TO設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SCORE_TO = 'TARGET/SET_SCORE_TO';

/**
 * 評点TO設定
 * @param   {string}  scoreTo  評点TO
 */
export const setScoreTo = (scoreTo) => ({
  type: SET_SCORE_TO, scoreTo,
});

/**
 * 格付け設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CLASSIFICATION_LIST = 'TARGET/SET_CLASSIFICATION_LIST';

/**
 * 格付け設定
 * @param   {object}  classificationList
 */
export const setClassificationList = (classificationList) => ({
  type: SET_CLASSIFICATION_LIST, classificationList,
});

/**
 * 事業所数FROM設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_OFFICE_COUNT_FROM = 'TARGET/SET_OFFICE_COUNT_FROM';

/**
  * 事業所数FROM設定
  * @param   {string}  officeCountFrom  事業所数FROM
  */
export const setOfficeCountFrom = (officeCountFrom) => ({
  type: SET_OFFICE_COUNT_FROM, officeCountFrom,
});

/**
  * 事業所数TO設定のAction識別文字列
  * @type    {string}  Action識別文字列
  */
export const SET_OFFICE_COUNT_TO = 'TARGET/SET_OFFICE_COUNT_TO';

/**
  * 事業所数TO設定
  * @param   {string}  officeCountTo  事業所数TO
  */
export const setOfficeCountTo = (officeCountTo) => ({
  type: SET_OFFICE_COUNT_TO, officeCountTo,
});

/**
 * 事業所区分リスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_JGKB_LIST = 'TARGET/SET_JGKB_LIST';

/**
 * 事業所区分リスト設定
 * @param   {string}  jgkbList  事業所区分リスト
 */
export const setJgkbList = (jgkbList = []) => ({
  type: SET_JGKB_LIST, jgkbList,
});

/**
 * 代表者苗字設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_REP_LAST_NAME = 'TARGET/SET_REP_LAST_NAME';

/**
  * 代表者苗字設定
  * @param   {string}  repLastName  代表者苗字
  */
export const setRepLastName = (repLastName) => ({
  type: SET_REP_LAST_NAME, repLastName,
});

/**
  * 代表者名前設定のAction識別文字列
  * @type    {string}  Action識別文字列
  */
export const SET_REP_FIRST_NAME = 'TARGET/SET_REP_FIRST_NAME';

/**
  * 代表者名前設定
  * @param   {string}  repFirstName  代表者名前
  */
export const setRepFirstName = (repFirstName) => ({
  type: SET_REP_FIRST_NAME, repFirstName,
});

/**
 * 取引情報有無設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ADDITIONALITEM = 'TARGET/SET_ADDITIONALITEM';

/**
 * 取引情報有無設定
 * @param   {string}  additionalitem  取引情報有無
 */
export const setAdditionalitem = (additionalitem) => ({
  type: SET_ADDITIONALITEM, additionalitem,
});

/**
 * 取引情報検索フラグ1のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TRADE_SEARCH_FLAG1 = 'TARGET/SET_TRADE_SEARCH_FLAG1';

/**
 * 取引情報検索フラグ1
 * @param   {string}  tradesearchflag1  取引情報検索フラグ1
 */
export const setTradesearchflag1 = (tradesearchflag1) => ({
  type: SET_TRADE_SEARCH_FLAG1, tradesearchflag1,
});

/**
 * 取引情報検索フラグ2のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TRADE_SEARCH_FLAG2 = 'TARGET/SET_TRADE_SEARCH_FLAG2';

/**
 * 取引情報検索フラグ2
 * @param   {string}  tradesearchflag2  取引情報検索フラグ2
 */
export const setTradesearchflag2 = (tradesearchflag2) => ({
  type: SET_TRADE_SEARCH_FLAG2, tradesearchflag2,
});

/**
 * 表示用資本金FROM(3桁カンマ)設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DISP_CAPITAL_FROM = 'TARGET/SET_DISP_CAPITAL_FROM';

/**
  * 表示用資本金FROM(3桁カンマ)設定
  * @param   {string}  dispCapitalFrom
  */
export const setDispCapitalFrom = (dispCapitalFrom) => ({
  type: SET_DISP_CAPITAL_FROM, dispCapitalFrom,
});

/**
  * 表示用資本金TO(3桁カンマ)設定のAction識別文字列
  * @type    {string}  Action識別文字列
  */
export const SET_DISP_CAPITAL_TO = 'TARGET/SET_DISP_CAPITAL_TO';

/**
  * 表示用資本金TO(3桁カンマ)設定
  * @param   {string}  dispCapitalTo
  */
export const setDispCapitalTo = (dispCapitalTo) => ({
  type: SET_DISP_CAPITAL_TO, dispCapitalTo,
});

/**
 * 表示用売上高FROM(3桁カンマ)設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DISP_SALES_FROM = 'TARGET/SET_DISP_SALES_FROM';

/**
 * 表示用売上高FROM(3桁カンマ)設定
 * @param   {string}  dispSalesFrom
 */
export const setDispSalesFrom = (dispSalesFrom) => ({
  type: SET_DISP_SALES_FROM, dispSalesFrom,
});

/**
 * 表示用売上高TO(3桁カンマ)設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DISP_SALES_TO = 'TARGET/SET_DISP_SALES_TO';

/**
 * 表示用売上高TO(3桁カンマ)設定
 * @param   {string}  dispSalesTo
 */
export const setDispSalesTo = (dispSalesTo) => ({
  type: SET_DISP_SALES_TO, dispSalesTo,
});

/**
 * 表示用売上高伸長率FROM(3桁カンマ)設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DISP_SALES_RATE_FROM = 'TARGET/SET_DISP_SALES_RATE_FROM';

/**
 * 表示用売上高伸長率FROM(3桁カンマ)設定
 * @param   {string}  dispSalesRateFrom
 */
export const setDispSalesRateFrom = (dispSalesRateFrom) => ({
  type: SET_DISP_SALES_RATE_FROM, dispSalesRateFrom,
});

/**
 * 表示用売上高伸長率TO(3桁カンマ)設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DISP_SALES_RATE_TO = 'TARGET/SET_DISP_SALES_RATE_TO';

/**
 * 表示用売上高伸長率TO(3桁カンマ)設定
 * @param   {string}  dispSalesRateTo
 */
export const setDispSalesRateTo = (dispSalesRateTo) => ({
  type: SET_DISP_SALES_RATE_TO, dispSalesRateTo,
});

/**
 * 表示用利益金FROM(3桁カンマ)設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DISP_BENEFIT_FROM = 'TARGET/SET_DISP_BENEFIT_FROM';

/**
  * 表示用利益金FROM(3桁カンマ)設定
  * @param   {string}  dispBenefitFrom
  */
export const setDispBenefitFrom = (dispBenefitFrom) => ({
  type: SET_DISP_BENEFIT_FROM, dispBenefitFrom,
});

/**
  * 表示用利益金TO(3桁カンマ)設定のAction識別文字列
  * @type    {string}  Action識別文字列
  */
export const SET_DISP_BENEFIT_TO = 'TARGET/SET_DISP_BENEFIT_TO';

/**
  * 表示用利益金TO(3桁カンマ)設定
  * @param   {string}  dispBenefitTo
  */
export const setDispBenefitTo = (dispBenefitTo) => ({
  type: SET_DISP_BENEFIT_TO, dispBenefitTo,
});

/**
  * 表示用利益金伸長率FROM(3桁カンマ)設定のAction識別文字列
  * @type    {string}  Action識別文字列
  */
export const SET_DISP_BENEFIT_RATE_FROM = 'TARGET/SET_DISP_BENEFIT_RATE_FROM';

/**
  * 表示用利益金伸長率FROM(3桁カンマ)設定
  * @param   {string}  dispBenefitRateFrom
  */
export const setDispBenefitRateFrom = (dispBenefitRateFrom) => ({
  type: SET_DISP_BENEFIT_RATE_FROM, dispBenefitRateFrom,
});

/**
  * 表示用利益金伸長率TO(3桁カンマ)設定のAction識別文字列
  * @type    {string}  Action識別文字列
  */
export const SET_DISP_BENEFIT_RATE_TO = 'TARGET/SET_DISP_BENEFIT_RATE_TO';

/**
  * 表示用利益金伸長率TO(3桁カンマ)設定
  * @param   {string}  dispBenefitRateTo
  */
export const setDispBenefitRateTo = (dispBenefitRateTo) => ({
  type: SET_DISP_BENEFIT_RATE_TO, dispBenefitRateTo,
});

/**
 * 表示用従業員数FROM(3桁カンマ)設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DISP_EMPLOYEES_FROM = 'TARGET/SET_DISP_EMPLOYEES_FROM';

/**
 * 表示用従業員数TO(3桁カンマ)設定
 * @param   {string}  dispEmployeesFrom
 */
export const setDispEmployeesFrom = (dispEmployeesFrom) => ({
  type: SET_DISP_EMPLOYEES_FROM, dispEmployeesFrom,
});

/**
 * 表示用従業員数TO(3桁カンマ)設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DISP_EMPLOYEES_TO = 'TARGET/SET_DISP_EMPLOYEES_TO';

/**
 * 表示用従業員数TO(3桁カンマ)設定
 * @param   {string}  dispEmployeesTo
 */
export const setDispEmployeesTo = (dispEmployeesTo) => ({
  type: SET_DISP_EMPLOYEES_TO, dispEmployeesTo,
});

/**
 * 表示用事業所数FROM(3桁カンマ)設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DISP_OFFICE_COUNT_FROM = 'TARGET/SET_DISP_OFFICE_COUNT_FROM';

/**
  * 表示用事業所数TO(3桁カンマ)設定
  * @param   {string}  dispOfficeCountFrom
  */
export const setDispOfficeCountFrom = (dispOfficeCountFrom) => ({
  type: SET_DISP_OFFICE_COUNT_FROM, dispOfficeCountFrom,
});

/**
  * 表示用事業所数TO(3桁カンマ)設定のAction識別文字列
  * @type    {string}  Action識別文字列
  */
export const SET_DISP_OFFICE_COUNT_TO = 'TARGET/SET_DISP_OFFICE_COUNT_TO';

/**
  * 表示用事業所数TO(3桁カンマ)設定
  * @param   {string}  dispOfficeCountTo
  */
export const setDispOfficeCountTo = (dispOfficeCountTo) => ({
  type: SET_DISP_OFFICE_COUNT_TO, dispOfficeCountTo,
});

/**
 * 表示用事業所区分リスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DISP_JGKB_LIST = 'TARGET/SET_DISP_JGKB_LIST';

/**
 * 表示用事業所区分リスト設定
 * @param   {string}  jgkbList
 */
export const setDispJgkbList = (dispJgkbList = []) => ({
  type: SET_DISP_JGKB_LIST, dispJgkbList,
});

/**
 * 資本金エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_CAPITAL = 'TARGET/SET_ERR_MSG_CAPITAL';

/**
  * 資本金エラーメッセージ設定
  * @param   {string}  errMsgCapital
  */
export const setErrMsgCapital = (errMsgCapital) => ({
  type: SET_ERR_MSG_CAPITAL, errMsgCapital,
});

/**
 * 売上高エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_SALES = 'TARGET/SET_ERR_MSG_SALES';

/**
 * 売上高エラーメッセージ設定
 * @param   {string}  errMsgSales
 */
export const setErrMsgSales = (errMsgSales) => ({
  type: SET_ERR_MSG_SALES, errMsgSales,
});

/**
 * 売上高伸長率エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_RATE = 'TARGET/SET_ERR_MSG_RATE';

/**
  * 売上高伸長率エラーメッセージ設定
  * @param   {string}  errMsgRate
  */
export const setErrMsgRate = (errMsgRate) => ({
  type: SET_ERR_MSG_RATE, errMsgRate,
});

/**
 * 利益金エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_BENEFIT = 'TARGET/SET_ERR_MSG_BENEFIT';

/**
  * 利益金エラーメッセージ設定
  * @param   {string}  errMsgBenefit
  */
export const setErrMsgBenefit = (errMsgBenefit) => ({
  type: SET_ERR_MSG_BENEFIT, errMsgBenefit,
});

/**
 * 利益伸長率エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_BENEFIT_RATE = 'TARGET/SET_ERR_MSG_BENEFIT_RATE';

/**
   * 利益伸長率エラーメッセージ設定
   * @param   {string}  errMsgBenefitRate
   */
export const setErrMsgBenefitRate = (errMsgBenefitRate) => ({
  type: SET_ERR_MSG_BENEFIT_RATE, errMsgBenefitRate,
});

/**
 * 従業員数エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_EMPLOYEES = 'TARGET/SET_ERR_MSG_EMPLOYEES';

/**
 * 従業員数エラーメッセージ設定
 * @param   {string}  errMsgEmployees
 */
export const setErrMsgEmployees = (errMsgEmployees) => ({
  type: SET_ERR_MSG_EMPLOYEES, errMsgEmployees,
});

/**
 * 設立年月エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_START_YM = 'TARGET/SET_ERR_MSG_START_YM';

/**
  * 設立年月エラーメッセージ設定
  * @param   {string}  errMsgStartYm
  */
export const setErrMsgStartYm = (errMsgStartYm) => ({
  type: SET_ERR_MSG_START_YM, errMsgStartYm,
});

/**
 * 国内最上位親会社DUNSエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_TOP_DUNS = 'TARGET/SET_ERR_MSG_TOP_DUNS';

/**
 * 国内最上位親会社DUNSエラーメッセージ設定
 * @param   {string}  errMsgTopDuns
 */
export const setErrMsgTopDuns = (errMsgTopDuns) => ({
  type: SET_ERR_MSG_TOP_DUNS, errMsgTopDuns,
});

/**
 * 評点エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_SCORE = 'TARGET/SET_ERR_MSG_SCORE';

/**
 * 評点エラーメッセージ設定
 * @param   {string}  errMsgScore
 */
export const setErrMsgScore = (errMsgScore) => ({
  type: SET_ERR_MSG_SCORE, errMsgScore,
});

/**
 * 事業所数エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_OFFICE_COUNT = 'TARGET/SET_ERR_MSG_OFFICE_COUNT';

/**
  * 事業所数エラーメッセージ設定
  * @param   {string}  errMsgOfficeCount
  */
export const setErrMsgOfficeCount = (errMsgOfficeCount) => ({
  type: SET_ERR_MSG_OFFICE_COUNT, errMsgOfficeCount,
});

/**
 * 商号漢字エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_SGKN = 'TARGET/SET_ERR_MSG_SGKN';

/**
  * 商号漢字エラーメッセージ設定
  * @param   {string}  errMsgSgkn
  */
export const setErrMsgSgkn = (errMsgSgkn) => ({
  type: SET_ERR_MSG_SGKN, errMsgSgkn,
});

/**
 * 資本金FROMエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_CAPITAL_FROM = 'TARGET/SET_CHECK_CAPITAL_FROM';

/**
  * 資本金FROMエラーフラグ設定
  * @param   {boolean}  checkCapitalFrom
  */
export const setCheckCapitalFrom = (checkCapitalFrom) => ({
  type: SET_CHECK_CAPITAL_FROM, checkCapitalFrom,
});

/**
  * 資本金TOエラーフラグ設定のAction識別文字列
  * @type    {string}  Action識別文字列
  */
export const SET_CHECK_CAPITAL_TO = 'TARGET/SET_CHECK_CAPITAL_TO';

/**
  * 資本金TOエラーフラグ設定
  * @param   {boolean}  checkCapitalTo
  */
export const setCheckCapitalTo = (checkCapitalTo) => ({
  type: SET_CHECK_CAPITAL_TO, checkCapitalTo,
});

/**
 * 代表者エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_REP_NAME = 'TARGET/SET_ERR_MSG_REP_NAME';

/**
  * 代表者エラーメッセージ設定
  * @param   {string}  errMsgRepName
  */
export const setErrMsgRepName = (errMsgRepName) => ({
  type: SET_ERR_MSG_REP_NAME, errMsgRepName,
});

/**
 * 概況エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_SYRK_GKNY = 'TARGET/SET_ERR_MSG_SYRK_GKNY';

/**
  * 概況エラーメッセージ設定
  * @param   {string}  errMsgSyrkGkny
  */
export const setErrMsgSyrkGkny = (errMsgSyrkGkny) => ({
  type: SET_ERR_MSG_SYRK_GKNY, errMsgSyrkGkny,
});

/**
 * 売上高FROMエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_SALES_FROM = 'TARGET/SET_CHECK_SALES_FROM';

/**
 * 売上高FROMエラーフラグ設定
 * @param   {boolean}  checkSalesFrom
 */
export const setCheckSalesFrom = (checkSalesFrom) => ({
  type: SET_CHECK_SALES_FROM, checkSalesFrom,
});

/**
 * 売上高TOエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_SALES_TO = 'TARGET/SET_CHECK_SALES_TO';

/**
 * 売上高TOエラーフラグ設定
 * @param   {boolean}  checkSalesTo
 */
export const setCheckSalesTo = (checkSalesTo) => ({
  type: SET_CHECK_SALES_TO, checkSalesTo,
});

/**
 * 売上高伸長率FROMエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_RATE_FROM = 'TARGET/SET_CHECK_RATE_FROM';

/**
  * 売上高伸長率FROMエラーフラグ設定
  * @param   {boolean}  checkRateFrom
  */
export const setCheckRateFrom = (checkRateFrom) => ({
  type: SET_CHECK_RATE_FROM, checkRateFrom,
});

/**
  * 売上高伸長率TOエラーフラグ設定のAction識別文字列
  * @type    {string}  Action識別文字列
  */
export const SET_CHECK_RATE_TO = 'TARGET/SET_CHECK_RATE_TO';

/**
  * 売上高伸長率TOエラーフラグ設定
  * @param   {boolean}  checkRateTo
  */
export const setCheckRateTo = (checkRateTo) => ({
  type: SET_CHECK_RATE_TO, checkRateTo,
});

/**
 * 利益金FROMエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_BENEFIT_FROM = 'TARGET/SET_CHECK_BENEFIT_FROM';

/**
  * 利益金FROMエラーフラグ設定
  * @param   {boolean}  checkBenefitFrom
  */
export const setCheckBenefitFrom = (checkBenefitFrom) => ({
  type: SET_CHECK_BENEFIT_FROM, checkBenefitFrom,
});

/**
  * 利益金TOエラーフラグ設定のAction識別文字列
  * @type    {string}  Action識別文字列
  */
export const SET_CHECK_BENEFIT_TO = 'TARGET/SET_CHECK_BENEFIT_TO';

/**
  * 利益金TOエラーフラグ設定
  * @param   {boolean}  checkBenefitTo
  */
export const setCheckBenefitTo = (checkBenefitTo) => ({
  type: SET_CHECK_BENEFIT_TO, checkBenefitTo,
});

/**
 * 利益伸長率FROMエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_BENEFIT_RATE_FROM = 'TARGET/SET_CHECK_BENEFIT_RATE_FROM';

/**
 * 利益伸長率FROMエラーフラグ設定
 * @param   {boolean}  checkBenefitRateFrom
 */
export const setCheckBenefitRateFrom = (checkBenefitRateFrom) => ({
  type: SET_CHECK_BENEFIT_RATE_FROM, checkBenefitRateFrom,
});

/**
 * 利益伸長率TOエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_BENEFIT_RATE_TO = 'TARGET/SET_CHECK_BENEFIT_RATE_TO';

/**
 * 利益伸長率TOエラーフラグ設定
 * @param   {boolean}  checkBenefitRateTo
 */
export const setCheckBenefitRateTo = (checkBenefitRateTo) => ({
  type: SET_CHECK_BENEFIT_RATE_TO, checkBenefitRateTo,
});

/**
 * 従業員数FROMエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_EMPLOYEES_FROM = 'TARGET/SET_CHECK_EMPLOYEES_FROM';

/**
 * 従業員数FROMエラーフラグ設定
 * @param   {boolean}  checkEmployeesFrom
 */
export const setCheckEmployeesFrom = (checkEmployeesFrom) => ({
  type: SET_CHECK_EMPLOYEES_FROM, checkEmployeesFrom,
});

/**
 * 従業員数TOエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_EMPLOYEES_TO = 'TARGET/SET_CHECK_EMPLOYEES_TO';

/**
 * 従業員数TOエラーフラグ設定
 * @param   {boolean}  checkEmployeesTo
 */
export const setCheckEmployeesTo = (checkEmployeesTo) => ({
  type: SET_CHECK_EMPLOYEES_TO, checkEmployeesTo,
});

/**
 * 設立年FROMエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_START_YEAR_FROM = 'TARGET/SET_CHECK_START_YEAR_FROM';

/**
  * 設立年FROMエラーフラグ設定
  * @param   {boolean}  checkStartYearFrom
  */
export const setCheckStartYearFrom = (checkStartYearFrom) => ({
  type: SET_CHECK_START_YEAR_FROM, checkStartYearFrom,
});

/**
 * 設立月FROMエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_START_MONTH_FROM = 'TARGET/SET_CHECK_START_MONTH_FROM';

/**
  * 設立月FROMエラーフラグ設定
  * @param   {boolean}  checkStartMonthFrom
  */
export const setCheckStartMonthFrom = (checkStartMonthFrom) => ({
  type: SET_CHECK_START_MONTH_FROM, checkStartMonthFrom,
});

/**
 * 設立年TOエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_START_YEAR_TO = 'TARGET/SET_CHECK_START_YEAR_TO';

/**
  * 設立年TOエラーフラグ設定
  * @param   {boolean}  checkStartYearTo
  */
export const setCheckStartYearTo = (checkStartYearTo) => ({
  type: SET_CHECK_START_YEAR_TO, checkStartYearTo,
});

/**
 * 設立月TOエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_START_MONTH_TO = 'TARGET/SET_CHECK_START_MONTH_TO';

/**
  * 設立月TOエラーフラグ設定
  * @param   {boolean}  checkStartMonthTo
  */
export const setCheckStartMonthTo = (checkStartMonthTo) => ({
  type: SET_CHECK_START_MONTH_TO, checkStartMonthTo,
});

/**
 * 国内最上位親会社DUNSエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_TOP_DUNS = 'TARGET/SET_CHECK_TOP_DUNS';

/**
 * 国内最上位親会社DUNSエラーフラグ設定
 * @param   {boolean}  checkTopDuns
 */
export const setCheckTopDuns = (checkTopDuns) => ({
  type: SET_CHECK_TOP_DUNS, checkTopDuns,
});

/**
 * 評点FROMエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_SCORE_FROM = 'TARGET/SET_CHECK_SCORE_FROM';

/**
 * 評点FROMエラーフラグ設定
 * @param   {boolean}  checkScoreFrom
 */
export const setCheckScoreFrom = (checkScoreFrom) => ({
  type: SET_CHECK_SCORE_FROM, checkScoreFrom,
});

/**
 * 評点TOエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_SCORE_TO = 'TARGET/SET_CHECK_SCORE_TO';

/**
 * 評点TOエラーフラグ設定
 * @param   {boolean}  checkScoreTo
 */
export const setCheckScoreTo = (checkScoreTo) => ({
  type: SET_CHECK_SCORE_TO, checkScoreTo,
});

/**
 * 事業所数FROMエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_OFFICE_COUNT_FROM = 'TARGET/SET_CHECK_OFFICE_COUNT_FROM';

/**
  * 事業所数FROMエラーフラグ設定
  * @param   {boolean}  checkOfficeCountFrom
  */
export const setCheckOfficeCountFrom = (checkOfficeCountFrom) => ({
  type: SET_CHECK_OFFICE_COUNT_FROM, checkOfficeCountFrom,
});

/**
  * 事業所数TOエラーフラグ設定のAction識別文字列
  * @type    {string}  Action識別文字列
  */
export const SET_CHECK_OFFICE_COUNT_TO = 'TARGET/SET_CHECK_OFFICE_COUNT_TO';

/**
  * 事業所数TOエラーフラグ設定
  * @param   {boolean}  checkOfficeCountTo
  */
export const setCheckOfficeCountTo = (checkOfficeCountTo) => ({
  type: SET_CHECK_OFFICE_COUNT_TO, checkOfficeCountTo,
});

/**
 * 代表者苗字エラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_REP_LAST_NAME = 'TARGET/SET_CHECK_REP_LAST_NAME';

/**
  * 代表者苗字エラーフラグ設定
  * @param   {boolean}  checkRepLastName
  */
export const setCheckRepLastName = (checkRepLastName) => ({
  type: SET_CHECK_REP_LAST_NAME, checkRepLastName,
});

/**
  * 代表者名前エラーフラグ設定のAction識別文字列
  * @type    {string}  Action識別文字列
  */
export const SET_CHECK_REP_FIRST_NAME = 'TARGET/SET_CHECK_REP_FIRST_NAME';

/**
  * 代表者名前エラーフラグ設定
  * @param   {boolean}  checkRepFirstName
  */
export const setCheckRepFirstName = (checkRepFirstName) => ({
  type: SET_CHECK_REP_FIRST_NAME, checkRepFirstName,
});

/**
 * 概況エラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_SYRK_GKNY = 'TARGET/SET_CHECK_SYRK_GKNY';

/**
  * 概況エラーフラグ設定
  * @param   {boolean}  checkSyrkGkny
  */
export const setCheckSyrkGkny = (checkSyrkGkny) => ({
  type: SET_CHECK_SYRK_GKNY, checkSyrkGkny,
});

/**
 * 商号漢字エラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_SGKN = 'TARGET/SET_CHECK_SGKN';

/**
  * 商号漢字エラーフラグ設定
  * @param   {boolean}  checkSgkn
  */
export const setCheckSgkn = (checkSgkn) => ({
  type: SET_CHECK_SGKN, checkSgkn,
});

/**
 * 都道府県リスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_PREF_LIST = 'TARGET/SET_PREF_LIST';

/**
 * 都道府県リスト設定
 * @param   {object}  prefList  都道府県リスト
 */
export const setPrefList = (prefList) => ({
  type: SET_PREF_LIST, prefList,
});

/**
 * 現在ページ番号設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_NOWPAGE = 'TARGET/SET_NOWPAGE';

/**
 * 現在ページ番号設定
 * @param   {number}  nowpage  現在ページ番号
 */
export const setNowpage = (nowpage) => ({
  type: SET_NOWPAGE, nowpage,
});

/**
 * 地域候補の選択コード設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SELECT_AREA = 'TARGET/SET_SELECT_AREA';

/**
 * 地域候補の選択コード設定
 * @param    {string}  selectArea 地域候補の選択コード
 */
export const setSelectArea = (selectArea) => ({
  type: SET_SELECT_AREA, selectArea,
});

/**
 * 都道府県候補の選択コード設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SELECT_PREF = 'TARGET/SET_SELECT_PREF';

/**
 * 都道府県候補の選択コード設定
 * @param    {string}  selectPref 都道府県候補の選択コード
 */
export const setSelectPref = (selectPref) => ({
  type: SET_SELECT_PREF, selectPref,
});

/**
 * 所在地キーワード設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ADDRESS_KEYWORD = 'TARGET/SET_ADDRESS_KEYWORD';

/**
  * 所在地キーワード設定
  * @param   {string}  addressKeyword  業種キーワード
  */
export const setAddressKeyword = (addressKeyword) => ({
  type: SET_ADDRESS_KEYWORD, addressKeyword,
});

/**
 * 所在地キーワードエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_ADDRESS_KEYWORD = 'TARGET/SET_ERR_MSG_ADDRESS_KEYWORD';

/**
  * 所在地キーワードエラーメッセージ設定
  * @param   {string}  errMsgAddressKeyword
  */
export const setErrMsgAddressKeyword = (errMsgAddressKeyword) => ({
  type: SET_ERR_MSG_ADDRESS_KEYWORD, errMsgAddressKeyword,
});

/**
 * 所在地キーワードエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_ADDRESS_KEYWORD = 'TARGET/SET_CHECK_ADDRESS_KEYWORD';

/**
  * 所在地キーワードエラーフラグ設定
  * @param   {boolean}  checkAddressKeyword
  */
export const setCheckAddressKeyword = (checkAddressKeyword) => ({
  type: SET_CHECK_ADDRESS_KEYWORD, checkAddressKeyword,
});

/**
 * 所在地選択キーワード検索結果設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ADDRESS_RESULT = 'TARGET/SET_ADDRESS_RESULT';

/**
  * 所在地選択キーワード検索結果設定
  * @param   {object}  addressResult  所在地検索結果
  */
export const setAddressResult = (addressResult) => ({
  type: SET_ADDRESS_RESULT, addressResult,
});

/**
 * 所在地条件選択内容追加設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ADDRESS_ADD_CONDITION = 'TARGET/SET_ADDRESS_ADD_CONDITION';

/**
 * 所在地条件選択内容追加設定
 * @param   {object}  addressAddCondition  所在地条件選択内容
 */
export const setAddressAddCondition = (addressAddCondition) => ({
  type: SET_ADDRESS_ADD_CONDITION, addressAddCondition,
});

/**
 * 所在地条件選択内容表示用のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ADDRESS_DISPLAY_CONDITION = 'TARGET/SET_ADDRESS_DISPLAY_CONDITION';

/**
 * 所在地条件選択内容表示用
 * @param   {object}  addressDisplayCondition  業種条件表示用
 */
export const setAddressDisplayCondition = (addressDisplayCondition) => ({
  type: SET_ADDRESS_DISPLAY_CONDITION, addressDisplayCondition,
});

/**
 * 所在地ポップアップ共通エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_ADDRESS_POP = 'TARGET/SET_ERR_MSG_ADDRESS_POP';

/**
 * 所在地ポップアップ共通エラーメッセージ設定
 * @param   {string}  errMsgAddressPop
 */
export const setErrMsgAddressPop = (errMsgAddressPop) => ({
  type: SET_ERR_MSG_ADDRESS_POP, errMsgAddressPop,
});

/**
 * 大分類候補の選択コードリスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SELECT_INDUSTRY_B = 'TARGET/SET_SELECT_INDUSTRY_B';

/**
 * 大分類候補の選択コードリスト設定
 * @param    {Array}  selectIndustryB 大分類候補の選択コードリスト
 */
export const setSelectIndustryB = (selectIndustryB = []) => ({
  type: SET_SELECT_INDUSTRY_B, selectIndustryB,
});

/**
 * 中分類候補の選択コードリスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SELECT_INDUSTRY_N = 'TARGET/SET_SELECT_INDUSTRY_N';

/**
 * 中分類候補の選択コードリスト設定
 * @param    {Array}  selectIndustryN 中分類候補の選択コードリスト
 */
export const setSelectIndustryN = (selectIndustryN = []) => ({
  type: SET_SELECT_INDUSTRY_N, selectIndustryN,
});

/**
 * 小分類候補の選択コードリスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SELECT_INDUSTRY_S = 'TARGET/SET_SELECT_INDUSTRY_S';

/**
 * 小分類候補の選択コードリスト設定
 * @param    {Array}  selectIndustryS 小分類候補の選択コードリスト
 */
export const setSelectIndustryS = (selectIndustryS = []) => ({
  type: SET_SELECT_INDUSTRY_S, selectIndustryS,
});

/**
 * 細分類候補の選択コードリスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SELECT_INDUSTRY_M = 'TARGET/SET_SELECT_INDUSTRY_M';

/**
 * 細分類候補の選択コードリスト設定
 * @param    {Array}  selectIndustryM 細分類候補の選択コードリスト
 */
export const setSelectIndustryM = (selectIndustryM = []) => ({
  type: SET_SELECT_INDUSTRY_M, selectIndustryM,
});

/**
 * 業種キーワード設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_INDUSTRY_KEYWORD = 'TARGET/SET_INDUSTRY_KEYWORD';

/**
  * 業種キーワード設定
  * @param   {string}  industryKeyword  業種キーワード
  */
export const setIndustryKeyword = (industryKeyword) => ({
  type: SET_INDUSTRY_KEYWORD, industryKeyword,
});

/**
 * 業種キーワードエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_INDUSTRY_KEYWORD = 'TARGET/SET_ERR_MSG_INDUSTRY_KEYWORD';

/**
  * 業種キーワードエラーメッセージ設定
  * @param   {string}  errMsgIndustryKeyword
  */
export const setErrMsgIndustryKeyword = (errMsgIndustryKeyword) => ({
  type: SET_ERR_MSG_INDUSTRY_KEYWORD, errMsgIndustryKeyword,
});

/**
 * 業種キーワードエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_INDUSTRY_KEYWORD = 'TARGET/SET_CHECK_INDUSTRY_KEYWORD';

/**
  * 業種キーワードエラーフラグ設定
  * @param   {boolean}  checkIndustryKeyword
  */
export const setCheckIndustryKeyword = (checkIndustryKeyword) => ({
  type: SET_CHECK_INDUSTRY_KEYWORD, checkIndustryKeyword,
});

/**
 * 業種選択内容重複エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_INDUSTRY_DUPLICATE = 'TARGET/SET_ERR_MSG_INDUSTRY_DUPLICATE';

/**
  * 業種選択内容重複エラーメッセージ設定
  * @param   {string}  errMsgIndustryDuplicate
  */
export const setErrMsgIndustryDuplicate = (errMsgIndustryDuplicate) => ({
  type: SET_ERR_MSG_INDUSTRY_DUPLICATE, errMsgIndustryDuplicate,
});

/**
 * 販売先取得フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */

export const SET_GET_CUSTOMER_COMPANY_FLG = 'TARGET/SET_GET_CUSTOMER_COMPANY_FLG';

/**
 * 販売先取得フラグ設定
 * @param   {string}  getCustomerCompanyFlg
 */
export const setGetCustomerCompanyFlg = (getCustomerCompanyFlg) => ({
  type: SET_GET_CUSTOMER_COMPANY_FLG, getCustomerCompanyFlg,
});

/**
 * 仕入先取得フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */

export const SET_GET_SUPPLIER_COMPANY_FLG = 'TARGET/SET_GET_SUPPLIER_COMPANY_FLG';

/**
 * 仕入先取得フラグ設定
 * @param   {string}  getSupplierCompanyFlg
 */
export const setGetSupplierCompanyFlg = (getSupplierCompanyFlg) => ({
  type: SET_GET_SUPPLIER_COMPANY_FLG, getSupplierCompanyFlg,
});

/**
 * 国内最上位親会社取得フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */

export const SET_GET_TOP_COMPANY_FLG = 'TARGET/SET_GET_TOP_COMPANY_FLG';

/**
 * 国内最上位親会社取得フラグ設定
 * @param   {string}  getTopCompanyFlg
 */
export const setGetTopCompanyFlg = (getTopCompanyFlg) => ({
  type: SET_GET_TOP_COMPANY_FLG, getTopCompanyFlg,
});

/**
 * 取引情報取得フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */

export const SET_GET_TRADE_INFO_FLG = 'TARGET/SET_GET_TRADE_INFO_FLG';

/**
 * 取引情報取得フラグ設定
 * @param   {string}  getTradeInfoFlg
 */
export const setGetTradeInfoFlg = (getTradeInfoFlg) => ({
  type: SET_GET_TRADE_INFO_FLG, getTradeInfoFlg,
});

/**
 *企業選択キーワード検索結果設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_COMPANY_RESULT = 'TARGET/SET_COMPANY_RESULT';

/**
 * 企業選択キーワード検索結果設定
 * @param   {object}  companyResult  業種条件
 */
export const setCompanyResult = (companyResult) => ({
  type: SET_COMPANY_RESULT, companyResult,
});

/**
 * 企業選択条件（販売先）設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CUSTOMER_COMPANY_CONDITION = 'TARGET/SET_CUSTOMER_COMPANY_CONDITION';

/**
 * 企業選択条件（販売先）設定
 * @param   {object}  customerCompanyCondition  企業条件
 */
export const setCustomerCompanyCondition = (customerCompanyCondition) => ({
  type: SET_CUSTOMER_COMPANY_CONDITION, customerCompanyCondition,
});

/**
 * 企業選択条件（販売先）選択内容追加設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CUSTOMER_COMPANY_ADD_CONDITION = 'TARGET/SET_CUSTOMER_COMPANY_ADD_CONDITION';

/**
 * 企業選択条件（販売先）選択内容追加設定
 * @param   {object}  customerCompanyAddCondition  業種条件選択内容
 */
export const setCustomerCompanyAddCondition = (customerCompanyAddCondition) => ({
  type: SET_CUSTOMER_COMPANY_ADD_CONDITION, customerCompanyAddCondition,
});

/**
 * 企業選択条件（販売先）選択内容表示用のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CUSTOMER_COMPANY_DISPLAY_CONDITION = 'TARGET/SET_CUSTOMER_COMPANY_DISPLAY_CONDITION';

/**
 * 企業選択条件（販売先）選択内容表示用
 * @param   {object}  customerCompanyDisplayCondition  業種条件表示用
 */
export const setCustomerCompanyDisplayCondition = (customerCompanyDisplayCondition) => ({
  type: SET_CUSTOMER_COMPANY_DISPLAY_CONDITION, customerCompanyDisplayCondition,
});

/**
 * 企業選択条件（仕入先）設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SUPPLIER_COMPANY_CONDITION = 'TARGET/SET_SUPPLIER_COMPANY_CONDITION';

/**
 * 企業選択条件（仕入先）設定
 * @param   {object}  supplierCompanyCondition  企業条件
 */
export const setSupplierCompanyCondition = (supplierCompanyCondition) => ({
  type: SET_SUPPLIER_COMPANY_CONDITION, supplierCompanyCondition,
});

/**
 * 企業選択条件（仕入先）選択内容追加設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SUPPLIER_COMPANY_ADD_CONDITION = 'TARGET/SET_SUPPLIER_COMPANY_ADD_CONDITION';

/**
 * 企業選択条件（仕入先）選択内容追加設定
 * @param   {object}  supplierCompanyAddCondition  業種条件選択内容
 */
export const setSupplierCompanyAddCondition = (supplierCompanyAddCondition) => ({
  type: SET_SUPPLIER_COMPANY_ADD_CONDITION, supplierCompanyAddCondition,
});

/**
 * 企業選択条件（仕入先）選択内容表示用のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SUPPLIER_COMPANY_DISPLAY_CONDITION = 'TARGET/SET_SUPPLIER_COMPANY_DISPLAY_CONDITION';

/**
 * 企業選択条件（仕入先）選択内容表示用
 * @param   {object}  supplierCompanyDisplayCondition  業種条件表示用
 */
export const setSupplierCompanyDisplayCondition = (supplierCompanyDisplayCondition) => ({
  type: SET_SUPPLIER_COMPANY_DISPLAY_CONDITION, supplierCompanyDisplayCondition,
});

/**
 * 企業選択条件（国内最上位親会社）設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TOP_COMPANY_CONDITION = 'TARGET/SET_TOP_COMPANY_CONDITION';

/**
 * 企業選択条件（国内最上位親会社）設定
 * @param   {object}  topCompanyCondition  企業条件
 */
export const setTopCompanyCondition = (topCompanyCondition) => ({
  type: SET_TOP_COMPANY_CONDITION, topCompanyCondition,
});

/**
 * 企業選択条件（国内最上位親会社）選択内容追加設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TOP_COMPANY_ADD_CONDITION = 'TARGET/SET_TOP_COMPANY_ADD_CONDITION';

/**
 * 企業選択条件（国内最上位親会社）選択内容追加設定
 * @param   {object}  topCompanyAddCondition  業種条件選択内容
 */
export const setTopCompanyAddCondition = (topCompanyAddCondition) => ({
  type: SET_TOP_COMPANY_ADD_CONDITION, topCompanyAddCondition,
});

/**
 * 企業選択条件（国内最上位親会社）選択内容表示用のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TOP_COMPANY_DISPLAY_CONDITION = 'TARGET/SET_TOP_COMPANY_DISPLAY_CONDITION';

/**
 * 企業選択条件（国内最上位親会社）選択内容表示用
 * @param   {object}  topCompanyDisplayCondition  業種条件表示用
 */
export const setTopCompanyDisplayCondition = (topCompanyDisplayCondition) => ({
  type: SET_TOP_COMPANY_DISPLAY_CONDITION, topCompanyDisplayCondition,
});
/**
 * 企業選択キーワード（DUNS）設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_COMPANY_DUNS_KEYWORD = 'TARGET/SET_COMPANY_DUNS_KEYWORD';

/**
  * 企業選択キーワード（DUNS）設定
  * @param   {string}  companyDunsKeyword  企業選択キーワード（DUNS）
  */
export const setCompanyDunsKeyword = (companyDunsKeyword) => ({
  type: SET_COMPANY_DUNS_KEYWORD, companyDunsKeyword,
});

/**
 * 企業選択キーワード（TSRコード）設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_COMPANY_TSR_KEYWORD = 'TARGET/SET_COMPANY_TSR_KEYWORD';

/**
  * 企業選択キーワード（TSRコード）設定
  * @param   {string}  companyTsrKeyword  企業選択キーワード（TSRコード）
  */
export const setCompanyTsrKeyword = (companyTsrKeyword) => ({
  type: SET_COMPANY_TSR_KEYWORD, companyTsrKeyword,
});

/**
 * 企業選択キーワード（企業名）設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_COMPANY_NAME_KEYWORD = 'TARGET/SET_COMPANY_NAME_KEYWORD';

/**
  * 企業選択キーワード（企業名）設定
  * @param   {string}  companyNameKeyword  企業選択キーワード（企業名）
  */
export const setCompanyNameKeyword = (companyNameKeyword) => ({
  type: SET_COMPANY_NAME_KEYWORD, companyNameKeyword,
});

/**
 * 企業名検索タイプ区分設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_COMPANY_NAME_SEARCH_TYPE = 'TARGET/SET_COMPANY_NAME_SEARCH_TYPE';

/**
 * 企業名検索タイプ区分設定
 * @param   {string}  companyNameSearchType
 */
export const setCompanyNameSearchType = (companyNameSearchType) => ({
  type: SET_COMPANY_NAME_SEARCH_TYPE, companyNameSearchType,
});

/**
 * 企業選択キーワード（法人番号）設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_COMPANY_HOJIN_KEYWORD = 'TARGET/SET_COMPANY_HOJIN_KEYWORD';

/**
  * 企業選択キーワード（法人番号）設定
  * @param   {string}  companyHojinKeyword  企業選択キーワード（法人番号）
  */
export const setCompanyHojinKeyword = (companyHojinKeyword) => ({
  type: SET_COMPANY_HOJIN_KEYWORD, companyHojinKeyword,
});

/**
 * 企業選択キーワード（DUNS）エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_COMPANY_DUNS_KEYWORD = 'TARGET/SET_ERR_MSG_COMPANY_DUNS_KEYWORD';

/**
  * 企業選択キーワード（DUNS）エラーメッセージ設定
  * @param   {string}  errMsgCompanyDunsKeyword
  */
export const setErrMsgCompanyDunsKeyword = (errMsgCompanyDunsKeyword) => ({
  type: SET_ERR_MSG_COMPANY_DUNS_KEYWORD, errMsgCompanyDunsKeyword,
});

/**
 * 企業選択キーワード（DUNS）エラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_COMPANY_DUNS_KEYWORD = 'TARGET/SET_CHECK_COMPANY_DUNS_KEYWORD';

/**
  * 企業選択キーワード（DUNS）エラーフラグ設定
  * @param   {boolean}  checkCompanyDunsKeyword
  */
export const setCheckCompanyDunsKeyword = (checkCompanyDunsKeyword) => ({
  type: SET_CHECK_COMPANY_DUNS_KEYWORD, checkCompanyDunsKeyword,
});

/**
 * 企業選択キーワード（TSRコード）エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_COMPANY_TSR_KEYWORD = 'TARGET/SET_ERR_MSG_COMPANY_TSR_KEYWORD';

/**
  * 企業選択キーワード（TSRコード）エラーメッセージ設定
  * @param   {string}  errMsgCompanyTsrKeyword
  */
export const setErrMsgCompanyTsrKeyword = (errMsgCompanyTsrKeyword) => ({
  type: SET_ERR_MSG_COMPANY_TSR_KEYWORD, errMsgCompanyTsrKeyword,
});

/**
 * 企業選択キーワード（TSRコード）エラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_COMPANY_TSR_KEYWORD = 'TARGET/SET_CHECK_COMPANY_TSR_KEYWORD';

/**
  * 企業選択キーワード（TSRコード）エラーフラグ設定
  * @param   {boolean}  checkCompanyTsrKeyword
  */
export const setCheckCompanyTsrKeyword = (checkCompanyTsrKeyword) => ({
  type: SET_CHECK_COMPANY_TSR_KEYWORD, checkCompanyTsrKeyword,
});

/**
 * 企業選択キーワード（企業名）エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_COMPANY_NAME_KEYWORD = 'TARGET/SET_ERR_MSG_COMPANY_NAME_KEYWORD';

/**
  * 企業選択キーワード（企業名）エラーメッセージ設定
  * @param   {string}  errMsgCompanyNameKeyword
  */
export const setErrMsgCompanyNameKeyword = (errMsgCompanyNameKeyword) => ({
  type: SET_ERR_MSG_COMPANY_NAME_KEYWORD, errMsgCompanyNameKeyword,
});

/**
 * 企業選択キーワード（企業名）エラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_COMPANY_NAME_KEYWORD = 'TARGET/SET_CHECK_COMPANY_NAME_KEYWORD';

/**
  * 企業選択キーワード（企業名）エラーフラグ設定
  * @param   {boolean}  checkCompanyNameKeyword
  */
export const setCheckCompanyNameKeyword = (checkCompanyNameKeyword) => ({
  type: SET_CHECK_COMPANY_NAME_KEYWORD, checkCompanyNameKeyword,
});

/**
 * 企業選択キーワード（法人番号）エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_COMPANY_HOJIN_KEYWORD = 'TARGET/SET_ERR_MSG_COMPANY_HOJIN_KEYWORD';

/**
  * 企業選択キーワード（法人番号）エラーメッセージ設定
  * @param   {string}  errMsgCompanyHojinKeyword
  */
export const setErrMsgCompanyHojinKeyword = (errMsgCompanyHojinKeyword) => ({
  type: SET_ERR_MSG_COMPANY_HOJIN_KEYWORD, errMsgCompanyHojinKeyword,
});

/**
 * 企業選択キーワード（法人番号）エラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_COMPANY_HOJIN_KEYWORD = 'TARGET/SET_CHECK_COMPANY_HOJIN_KEYWORD';

/**
  * 企業選択キーワード（法人番号）エラーフラグ設定
  * @param   {boolean}  checkCompanyHojinKeyword
  */
export const setCheckCompanyHojinKeyword = (checkCompanyHojinKeyword) => ({
  type: SET_CHECK_COMPANY_HOJIN_KEYWORD, checkCompanyHojinKeyword,
});

/**
 * 企業選択内容重複エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_COMPANY_DUPLICATE = 'TARGET/SET_ERR_MSG_COMPANY_DUPLICATE';

/**
  * 企業選択内容重複エラーメッセージ設定
  * @param   {string}  errMsgCompanyDuplicate
  */
export const setErrMsgCompanyDuplicate = (errMsgCompanyDuplicate) => ({
  type: SET_ERR_MSG_COMPANY_DUPLICATE, errMsgCompanyDuplicate,
});

/**
 * 件数上限メッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_LIMIT_MESSAGE = 'TARGET/SET_LIMIT_MESSAGE';

/**
 * 件数上限メッセージ設定
 * @param    {string}  limitMessage 件数上限メッセージ
 */
export const setLimitMessage = (limitMessage) => ({
  type: SET_LIMIT_MESSAGE, limitMessage,
});

/**
 * 検索条件初期化
 * @type    {string}  Action識別文字列
 */
export const SET_INIT_SEARCH_CONDITION = 'TARGET/SET_INIT_SEARCH_CONDITION';

/**
 * 画面表示検索条件クリア
 */
export const setInitSearchCondition = () => ({
  type: SET_INIT_SEARCH_CONDITION,
});

/**
 * 取引条件項目リスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TRADE_INFO_SEARCH_ITEM_LIST = 'TARGET/SET_TRADE_INFO_SEARCH_ITEM_LIST';

/**
 * 取引条件項目リスト設定
 * @param   {object}  tradeInfoSearchItemList 取引条件項目リスト
 */
export const setTradeInfoSearchItemList = (tradeInfoSearchItemList) => ({
  type: SET_TRADE_INFO_SEARCH_ITEM_LIST, tradeInfoSearchItemList,
});

/**
 * 結果項目リスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TARGET_LIST_HEADER_ITEM = 'TARGET/SET_TARGET_LIST_HEADER_ITEM';

/**
 * 結果項目リスト設定
 * @param   {Array}  targetListHeaderItem 結果項目リスト
 */
export const setTargetListHeaderItem = (targetListHeaderItem) => ({
  type: SET_TARGET_LIST_HEADER_ITEM, targetListHeaderItem,
});

/**
 * 結果リスト横幅設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TARGET_LIST_HEADER_WIDTH = 'TARGET/SET_TARGET_LIST_HEADER_WIDTH';

/**
 * 結果リスト横幅設定
 * @param   {number}  targetListHeaderWidth 結果リスト横幅
 */
export const setTargetListHeaderWidth = (targetListHeaderWidth) => ({
  type: SET_TARGET_LIST_HEADER_WIDTH, targetListHeaderWidth,
});

/**
 * ターゲット検索一覧のカテゴリ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TARGET_LIST_CATEGORY = 'TARGET/SET_TARGET_LIST_CATEGORY';

/**
 * ターゲット検索一覧のカテゴリ設定
 * @param   {number}  targetListCategory ターゲット検索一覧のカテゴリ
 */
export const setTargetListCategory = (targetListCategory) => ({
  type: SET_TARGET_LIST_CATEGORY, targetListCategory,
});

/**
 * 取引条件項目設定設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TRADE_INFO_SEARCH_ITEM = 'TARGET/SET_TRADE_INFO_SEARCH_ITEM';

/**
 * 取引条件項目設定設定
 * @param   {string}  tradeInfoSearchItem 取引条件項目設定
 */
export const setTradeInfoSearchItem = (tradeInfoSearchItem) => ({
  type: SET_TRADE_INFO_SEARCH_ITEM, tradeInfoSearchItem,
});

/**
 * 取引情報条件選択内容設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TRADE_INFO_ADD_CONDITION = 'TARGET/SET_TRADE_INFO_ADD_CONDITION';

/**
 * 取引情報条件選択内容設定
 * @param   {object}  tradeInfoAddCondition 取引情報条件選択内容
 */
export const setTradeInfoAddCondition = (tradeInfoAddCondition) => ({
  type: SET_TRADE_INFO_ADD_CONDITION, tradeInfoAddCondition,
});

/**
 * 取引情報条件設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TRADE_INFO_CONDITION = 'TARGET/SET_TRADE_INFO_CONDITION';

/**
 * 取引情報条件設定
 * @param   {object}  tradeInfoCondition 取引情報条件
 */
export const setTradeInfoCondition = (tradeInfoCondition) => ({
  type: SET_TRADE_INFO_CONDITION, tradeInfoCondition,
});

/**
 * 取引情報条件ポップアップのON、OFFのフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TRADE_INFO_POP_FLG = 'TARGET/SET_TRADE_INFO_POP_FLG';

/**
 * 取引情報条件ポップアップのON、OFFのフラグ設定
 * @param   {boolean}  tradeInfoPopFlg 取引情報条件ポップアップのON、OFFのフラグ
 */
export const setTradeInfoPopFlg = (tradeInfoPopFlg) => ({
  type: SET_TRADE_INFO_POP_FLG, tradeInfoPopFlg,
});

/**
 * 国内最上位親会社TSRコード設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TOP_TSR_CODE = 'TARGET/SET_TOP_TSR_CODE';

/**
 * 国内最上位親会社TSRコード設定
 * @param   {string}  topTsrCode 国内最上位親会社ＴＳＲコード
 */
export const setTopTsrCode = (topTsrCode) => ({
  type: SET_TOP_TSR_CODE, topTsrCode,
});

/**
 * 国内最上位親会社TSRコードエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_TOP_TSR_CODE = 'TARGET/SET_ERR_MSG_TOP_TSR_CODE';

/**
 * 国内最上位親会社TSRコードエラーメッセージ設定
 * @param   {string}  errMsgTopTsrCode 国内最上位親会社ＴＳＲコードエラーメッセージ
 */
export const setErrMsgTopTsrCode = (errMsgTopTsrCode) => ({
  type: SET_ERR_MSG_TOP_TSR_CODE, errMsgTopTsrCode,
});

/**
 * 取引条件値エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_TRADE_INFO_SEARCH_VALUE = 'TARGET/SET_ERR_MSG_TRADE_INFO_SEARCH_VALUE';

/**
 * 取引条件値エラーメッセージ設定
 * @param   {string}  errMsgTradeInfoSearchValue 取引条件値エラーメッセージ
 */
export const setErrMsgTradeInfoSearchValue = (errMsgTradeInfoSearchValue) => ({
  type: SET_ERR_MSG_TRADE_INFO_SEARCH_VALUE, errMsgTradeInfoSearchValue,
});

/**
 * 取引条件選択内容件数超過エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_TRADE_INFO_LIMIT = 'TARGET/SET_ERR_MSG_TRADE_INFO_LIMIT';

/**
 * 取引条件選択内容件数超過エラーメッセージ設定
 * @param   {string}  errMsgTradeInfoLimit 取引条件選択内容件数超過エラーメッセージ
 */
export const setErrMsgTradeInfoLimit = (errMsgTradeInfoLimit) => ({
  type: SET_ERR_MSG_TRADE_INFO_LIMIT, errMsgTradeInfoLimit,
});

/**
 * 取引条件選択内容必須エラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_TRADE_INFO_REQUIRED = 'TARGET/SET_ERR_MSG_TRADE_INFO_REQUIRED';

/**
 * 取引条件選択内容必須エラーメッセージ設定
 * @param   {string}  errMsgTradeInfoRequired 取引条件選択内容件数超過エラーメッセージ
 */
export const setErrMsgTradeInfoRequired = (errMsgTradeInfoRequired) => ({
  type: SET_ERR_MSG_TRADE_INFO_REQUIRED, errMsgTradeInfoRequired,
});

/**
 * 国内最上位親会社TSRコードエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_TOP_TSR_CODE = 'TARGET/SET_CHECK_TOP_TSR_CODE';

/**
 * 国内最上位親会社TSRコードエラーフラグ設定
 * @param   {boolean}  checkTopTsrCode 国内最上位親会社TSRコードエラーフラグ
 */
export const setCheckTopTsrCode = (checkTopTsrCode) => ({
  type: SET_CHECK_TOP_TSR_CODE, checkTopTsrCode,
});

/**
 * 取引条件値エラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_TRADE_INFO_SEARCH_VALUE = 'TARGET/SET_CHECK_TRADE_INFO_SEARCH_VALUE';

/**
 * 取引条件値エラーフラグ設定
 * @param   {boolean}  checkTradeInfoSearchValue 取引条件値エラーフラグ
 */
export const setCheckTradeInfoSearchValue = (checkTradeInfoSearchValue) => ({
  type: SET_CHECK_TRADE_INFO_SEARCH_VALUE, checkTradeInfoSearchValue,
});

/**
 * 取引条件選択内容件数超過エラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHECK_TRADE_INFO_LIMIT = 'TARGET/SET_CHECK_TRADE_INFO_LIMIT';

/**
 * 取引条件選択内容件数超過エラーフラグ設定
 * @param   {boolean}  checkTradeInfoLimit 取引条件選択内容件数超過エラーフラグ
 */
export const setCheckTradeInfoLimit = (checkTradeInfoLimit) => ({
  type: SET_CHECK_TRADE_INFO_LIMIT, checkTradeInfoLimit,
});

/**
 * 取引条件値エラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_IMPORT_FILE = 'TARGET/SET_IMPORT_FILE';

/**
 * 企業情報一覧、結果件数、全体件数設定
 * @param   {object}  importFile  企業情報一覧、結果件数、全体件数
 */
export const setImportFile = (importFile) => ({
  type: SET_IMPORT_FILE, importFile,
});

/**
 * Salesforce送信確認ポップアップのON、OFFのフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SEND_SALESFORCE_POP_FLG = 'TARGET/SET_SEND_SALESFORCE_POP_FLG';

/**
 * Salesforce送信確認ポップアップのON、OFFのフラグ設定
 * @param   {boolean}  sendSalesforcePopFlg  Salesforce送信確認ポップアップのON、OFFのフラグ
 */
export const setSendSalesforcePopFlg = (sendSalesforcePopFlg) => ({
  type: SET_SEND_SALESFORCE_POP_FLG, sendSalesforcePopFlg,
});

/**
 * Salesforce送信確認 ターゲットリスト名称設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SEND_SALESFORCE_TARGET_NAME = 'TARGET/SET_SEND_SALESFORCE_TARGET_NAME';

/**
 * Salesforce送信確認 ターゲットリスト名称設定
 * @param   {string}  sendSalesforceTargetName  Salesforce送信確認 ターゲットリスト名称
 */
export const setSendSalesforceTargetName = (sendSalesforceTargetName) => ({
  type: SET_SEND_SALESFORCE_TARGET_NAME, sendSalesforceTargetName,
});

/**
 * Salesforce送信 入力チェックMSGのAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_SALESFORCE_TARGET_NAME = 'TARGET/SET_ERR_MSG_SALESFORCE_TARGET_NAME';

/**
 * Salesforce送信 入力チェックMSGの設定
 * @param   {boolean}  errMsgSalesforceTargetName  Salesforce送信 入力チェックMSG
 */
export const setErrMsgSalesforceTargetName = (errMsgSalesforceTargetName) => ({
  type: SET_ERR_MSG_SALESFORCE_TARGET_NAME, errMsgSalesforceTargetName,
});

/**
 * Salesforce送信 連携マッピング 連携先オブジェクトのAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SALESFORCE_MAP_OBJECT = 'TARGET/SET_SALESFORCE_MAP_OBJECT';

/**
 * Salesforce送信 連携マッピング 連携先オブジェクトの設定
 * @param   {boolean}  salesforceMapObject  Salesforce送信 連携マッピング 連携先オブジェクト
 */
export const setSalesforceMapObject = (salesforceMapObject) => ({
  type: SET_SALESFORCE_MAP_OBJECT, salesforceMapObject,
});

/**
 * Salesforce送信 連携マッピング 連携先オブジェクト名のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SALESFORCE_MAP_OBJECT_NAME = 'TARGET/SET_SALESFORCE_MAP_OBJECT_NAME';

/**
 * Salesforce送信 連携マッピング 連携先オブジェクト名の設定
 * @param   {boolean}  salesforceMapObjectName  Salesforce送信 連携マッピング 連携先オブジェクト
 */
export const setSalesforceMapObjectName = (salesforceMapObjectName) => ({
  type: SET_SALESFORCE_MAP_OBJECT_NAME, salesforceMapObjectName,
});

/**
 * Salesforce送信 連携マッピング 連携方式区分のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SALESFORCE_MAP_MODE_KBN = 'TARGET/SET_SALESFORCE_MAP_MODE_KBN';

/**
 * Salesforce送信 連携マッピング 連携方式区分の設定
 * @param   {boolean}  salesforceMapModeKbn  Salesforce送信 連携マッピング 連携方式区分
 */
export const setSalesforceMapModeKbn = (salesforceMapModeKbn) => ({
  type: SET_SALESFORCE_MAP_MODE_KBN, salesforceMapModeKbn,
});

/**
 * Salesforce送信 連携マッピング 連携方式名のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SALESFORCE_MAP_COLUMN_NAME = 'TARGET/SET_SALESFORCE_MAP_COLUMN_NAME';

/**
 * Salesforce送信 連携マッピング 連携方式名の設定
 * @param   {boolean}  salesforceMapColumnName  Salesforce送信 連携マッピング 連携方式名
 */
export const setSalesforceMapColumnName = (salesforceMapColumnName) => ({
  type: SET_SALESFORCE_MAP_COLUMN_NAME, salesforceMapColumnName,
});

/**
 * Salesforce送信 連携マッピング 送信先項目リストのAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SALESFORCE_MAP_FIELD_LIST = 'TARGET/SET_SALESFORCE_MAP_FIELD_LIST';

/**
 * Salesforce送信 連携マッピング 送信先項目リストの設定
 * @param   {boolean}  salesforceMapFieldList  Salesforce送信 連携マッピング 送信先項目リスト
 */
export const setSalesforceMapFieldList = (salesforceMapFieldList) => ({
  type: SET_SALESFORCE_MAP_FIELD_LIST, salesforceMapFieldList,
});

/**
 * Salesforce送信 上限チェック件数のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SALESFORCE_MAX_CHECK_COUNT = 'TARGET/SET_SALESFORCE_MAX_CHECK_COUNT';

/**
 * Salesforce送信 上限チェック件数の設定
 * @param   {boolean}  salesforceMapFieldList  Salesforce送信 上限チェック件数
 */
export const setSalesforceMaxCheckCount = (salesforceMaxCheckCount) => ({
  type: SET_SALESFORCE_MAX_CHECK_COUNT, salesforceMaxCheckCount,
});

/**
 * 外部送信確認ポップアップのON、OFFのフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SEND_EXTERNAL_POP_FLG = 'TARGET/SET_SEND_EXTERNAL_POP_FLG';

/**
 * 外部送信確認ポップアップのON、OFFのフラグ設定
 * @param   {boolean}  sendExternalPopFlg  外部送信確認ポップアップのON、OFFのフラグ
 */
export const setSendExternalPopFlg = (sendExternalPopFlg) => ({
  type: SET_SEND_EXTERNAL_POP_FLG, sendExternalPopFlg,
});

/**
 * 外部送信確認 出力項目レイアウトの選択値設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SEND_EXTERNAL_CONFIG = 'TARGET/SET_SEND_EXTERNAL_CONFIG';

/**
 * 外部送信確認 出力項目レイアウトの選択値設定
 * @param   {string}  sendExternalConfig  外部送信確認 出力項目レイアウトの選択値
 */
export const setSendExternalConfig = (sendExternalConfig) => ({
  type: SET_SEND_EXTERNAL_CONFIG, sendExternalConfig,
});

/**
 * 外部送信確認 ターゲットリスト名称設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SEND_EXTERNAL_TARGET_NAME = 'TARGET/SET_SEND_EXTERNAL_TARGET_NAME';

/**
 * 外部送信確認 ターゲットリスト名称設定
 * @param   {string}  sendExternalTargetName  外部送信確認 ターゲットリスト名称
 */
export const setSendExternalTargetName = (sendExternalTargetName) => ({
  type: SET_SEND_EXTERNAL_TARGET_NAME, sendExternalTargetName,
});

/**
 * 外部送信結果MSGポップアップのON、OFFのフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SEND_EXTERNAL_RESULT_POP_FLG = 'TARGET/SET_SEND_EXTERNAL_RESULT_POP_FLG';

/**
 * 外部送信結果MSGポップアップのON、OFFのフラグ設定
 * @param   {boolean}  sendExternalResultPopFlg  外部送信結果MSGポップアップのON、OFFのフラグ
 * @param   {boolean}  sendExternalLimitOverFlg  外部送信結果 件数超過のON、OFFのフラグ
 */
export const setSendExternalResultPopFlg = (
  sendExternalResultPopFlg,
  sendExternalLimitOverFlg = false,
) => ({
  type: SET_SEND_EXTERNAL_RESULT_POP_FLG,
  sendExternalResultPopFlg,
  sendExternalLimitOverFlg,
});

/**
 * 外部送信 入力チェックMSGのAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MSG_EXTERNAL_TARGET_NAME = 'TARGET/SET_ERR_MSG_EXTERNAL_TARGET_NAME';

/**
 * 外部送信 入力チェックMSGの設定
 * @param   {boolean}  errMsgExternalTargetName  外部送信 入力チェックMSG
 */
export const setErrMsgExternalTargetName = (errMsgExternalTargetName) => ({
  type: SET_ERR_MSG_EXTERNAL_TARGET_NAME, errMsgExternalTargetName,
});

/**
 * 外部送信 上限チェック件数のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_EXTERNAL_MAX_CHECK_COUNT = 'TARGET/SET_EXTERNAL_MAX_CHECK_COUNT';

/**
 * 外部送信 上限チェック件数の設定
 * @param   {boolean}  externalMaxCheckCount  外部送信 上限チェック件数
 */
export const setExternalMaxCheckCount = (externalMaxCheckCount) => ({
  type: SET_EXTERNAL_MAX_CHECK_COUNT, externalMaxCheckCount,
});

/**
 * 外部送信 エラーメッセージのAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_EXTERNAL_ERR_MSG = 'TARGET/SET_EXTERNAL_ERR_MSG';

/**
 * 外部送信 エラーメッセージの設定
 * @param   {boolean}  externalMaxCheckCount  外部送信 エラーメッセージ
 */
export const setExternalErrMsg = (externalErrMsg) => ({
  type: SET_EXTERNAL_ERR_MSG, externalErrMsg,
});

/**
 * ダウンロードステータス取得
 * ・取得したステータスが処理中の場合、TRUEを返却
 */
export const getDownloadStatus = () => async (dispatch) => {
  // 検索条件作成
  const o = {
    process_type: CREATE_FILE_PROCESS_KBN.DOWNLOAD_POSSIBLE,
  };
  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.CREATE_COMPANY_OFFICE_FILE_MULTI, o);
  // ワーニングの場合
  if (ret.result === RESULT_CODE.WARN) {
    return false;
  }

  // ネットワークエラーの場合
  if (ret.result === RESULT_CODE.ANOMALY) {
    dispatch(setErrorMessage(ERROR.E09013));
    dispatch(setDownloadStatus());
    return false;
  }

  // 認証エラーの場合は何も設定しない
  if (ret.result === RESULT_CODE.ERROR && ret.response === null) {
    return false;
  }

  // エラーの場合、ダウンロードステータス情報を初期化する
  if (ret.result === RESULT_CODE.ERROR && ret.response !== null) {
    await dispatch(setErrorMessage(ERROR.E09015));
    dispatch(setDownloadStatus());
    return false;
  }
  // ダウンロードステータス情報を更新する
  dispatch(setDownloadStatus(ret.response));

  // ステータスが処理中かどうかを返却
  return ret.response.status === PROCESS_STATUS.PROCESSING;
};

/**
  * ポーリング処理停止
  */
export const stopDownloadPolling = () => (dispatch, getState) => {
  const { pollingId } = getState().target;
  // ポーリングIDが設定されている場合、ポーリング処理停止
  if (pollingId) {
    clearInterval(pollingId);
    dispatch(setPollingId());
  }
};

/**
  * ポーリング処理開始
 */
export const startDownloadPolling = () => (dispatch, getState) => {
  const { pollingId } = getState().target;
  if (!pollingId) {
    const pId = setInterval(async () => {
      const res = await dispatch(getDownloadStatus());
      if (!res) {
        // ダウンロードステータスが処理中以外の場合、ポーリング処理を停止
        dispatch(stopDownloadPolling());
      }
    }, config.DOWNLOAD_POLLING.TARGET_DOWNLOAD);
    dispatch(setPollingId(pId));
  }
};

/**
 * 検索条件生成
 * ・画面で選択した検索条件から、リクエストパラメータ用、画面表示用検索条件を作成し一時保存領域に設定
 */
export const createSearchCondition = (saveFlg = '0') => (dispatch, getState) => {
  const {
    searchTarget,
    addressCondition,
    industryCondition,
    productsCondition,
    mainIndustryFlg,
    accountMonth,
    capitalFrom,
    capitalTo,
    salesFrom,
    salesTo,
    latestFlg,
    salesRateFrom,
    salesRateTo,
    benefitFrom,
    benefitTo,
    benefitRateFrom,
    benefitRateTo,
    employeeFrom,
    employeeTo,
    topDuns,
    topTsrCode,
    scoreFrom,
    scoreTo,
    officeCountFrom,
    officeCountTo,
    repLastName,
    repFirstName,
    additionalitem,
    tradesearchflag1,
    tradesearchflag2,
    tradeInfoCondition,
    sgkn,
    sgknSearchType,
    startYearFrom,
    startMonthFrom,
    startYearTo,
    startMonthTo,
    syrkGkny,
    jgkbList,
    classificationList,
    marketSegment,
    customerCompanyCondition,
    supplierCompanyCondition,
    topCompanyCondition,
    targetingDispItems,
  } = getState().target;

  // 検索対象以外の項目が全て未選択の場合、エラーメッセージを表示
  if (!((accountMonth && accountMonth.length > 0)
    || (addressCondition && addressCondition.length > 0)
    || (industryCondition && industryCondition.length > 0)
    || (productsCondition && productsCondition.length > 0)
    || capitalFrom
    || capitalTo
    || salesFrom
    || salesTo
    || salesRateFrom
    || salesRateTo
    || benefitFrom
    || benefitTo
    || benefitRateFrom
    || benefitRateTo
    || employeeFrom
    || employeeTo
    || topDuns
    || topTsrCode
    || scoreFrom
    || scoreTo
    || officeCountFrom
    || officeCountTo
    || repLastName
    || repFirstName
    || sgkn
    || startYearFrom
    || startMonthFrom
    || startYearTo
    || startMonthTo
    || syrkGkny
    || (jgkbList && jgkbList.length > 0)
    || (classificationList && classificationList.length > 0)
    || (marketSegment && marketSegment.length > 0)
    || (customerCompanyCondition && customerCompanyCondition.length > 0)
    || (supplierCompanyCondition && supplierCompanyCondition.length > 0)
    || (topCompanyCondition && topCompanyCondition.length > 0)
    || (additionalitem && additionalitem === CONDITION_RADIO.CONDITION_TRUE)
    || (tradesearchflag1 && tradesearchflag1 === CONDITION_RADIO.CONDITION_TRUE)
    || (tradesearchflag2 && tradesearchflag2 === CONDITION_RADIO.CONDITION_TRUE)
    || (tradeInfoCondition && tradeInfoCondition.length > 0))) {
    dispatch(setErrorMessage(getMessage(ERROR.E02002)));
    return false;
  }

  const o = {
    // 検索対象
    search_target: searchTarget,
  };
  // 主業種フラグ
  if (mainIndustryFlg) {
    o.shugyoshu_flg = mainIndustryFlg;
  }
  // 資本金
  if (capitalFrom) {
    o.capital_from = capitalFrom;
  }
  if (capitalTo) {
    o.capital_to = capitalTo;
  }
  // 売上高
  if (salesFrom) {
    o.sales_from = salesFrom;
  }
  if (salesTo) {
    o.sales_to = salesTo;
  }
  // 決算情報最新期フラグ
  let dispLatestFlg = false;
  if (targetingDispItems) {
    targetingDispItems.search_option_list.forEach((label) => {
      if (label.item_name === TARGET_SEARCH_DISP_ITEM.SETTLEMENT) {
        dispLatestFlg = true;
      }
    });
  }
  if (latestFlg && dispLatestFlg) {
    o.latest_flg = latestFlg;
  } else {
    o.latest_flg = LATEST_FLG.LATEST_ON;
  }

  // 売上高伸長率
  if (salesRateFrom) {
    o.sales_growth_rate_from = salesRateFrom;
  }
  if (salesRateTo) {
    o.sales_growth_rate_to = salesRateTo;
  }
  // 利益金
  if (benefitFrom) {
    o.benefit_from = benefitFrom;
  }
  if (benefitTo) {
    o.benefit_to = benefitTo;
  }
  // 利益金伸長率
  if (benefitRateFrom) {
    o.benefit_growth_rate_from = benefitRateFrom;
  }
  if (benefitRateTo) {
    o.benefit_growth_rate_to = benefitRateTo;
  }
  // 従業員数
  if (employeeFrom) {
    o.employees_num_from = employeeFrom;
  }
  if (employeeTo) {
    o.employees_num_to = employeeTo;
  }
  // 国内最上位親会社DUNS
  if (topDuns) {
    o.series_top_duns = topDuns;
  }
  // 国内最上位親会社TSRコード
  if (topTsrCode) {
    o.series_top_tsr_code = topTsrCode;
  }
  // 評点
  if (scoreFrom) {
    o.score_from = scoreFrom;
  }
  if (scoreTo) {
    o.score_to = scoreTo;
  }
  // 事業所数
  if (officeCountFrom) {
    o.office_count_from = officeCountFrom;
  }
  if (officeCountTo) {
    o.office_count_to = officeCountTo;
  }
  // 代表者
  if (repLastName) {
    o.rep_last_name = repLastName;
  }
  if (repFirstName) {
    o.rep_first_name = repFirstName;
  }
  // 商号漢字
  if (sgkn) {
    o.sgkn = sgkn;
  }
  // 商号漢字検索タイプ区分
  if (sgknSearchType) {
    o.sgkn_search_type = sgknSearchType;
  }
  // 格付け
  if (classificationList && classificationList.length > 0) {
    o.tsr_kdkb_list = classificationList;
  }
  // 上場市場区分
  if (marketSegment && marketSegment.length > 0) {
    o.jjkb = marketSegment;
  }
  // 概況
  if (syrkGkny) {
    o.syrk_gkny = syrkGkny;
  }
  // 設立年月
  if (startYearFrom) {
    let startFrom;
    if (startMonthFrom) {
      startFrom = startYearFrom + startMonthFrom.toString().padStart(2, '0');
    } else {
      startFrom = `${startYearFrom}00`;
    }
    o.strt_ym_from = startFrom;
  }
  if (startYearTo) {
    let startTo;
    if (startMonthTo) {
      startTo = startYearTo + startMonthTo.toString().padStart(2, '0');
    } else {
      startTo = `${startYearTo}99`;
    }
    o.strt_ym_to = startTo;
  }

  const param = { ...o };

  // 取引情報有無
  if (additionalitem && additionalitem !== CONDITION_RADIO.CONDITION_NONE) {
    o.additional_item = additionalitem;
  } else if (saveFlg === GET_SAVE_FLG.ON && additionalitem === CONDITION_RADIO.CONDITION_NONE) {
    param.additional_item = additionalitem;
  }

  // 取引情報検索フラグ1(取引情報有無が選択されている場合だけリクエストパラメータに設定)
  if (additionalitem !== CONDITION_RADIO.CONDITION_FALSE
    && tradesearchflag1 && tradesearchflag1 !== CONDITION_RADIO.CONDITION_NONE) {
    param.trade_search_flag1 = tradesearchflag1;
    o.trade_search_flag1 = tradesearchflag1;
  }

  // 取引情報検索フラグ2(取引情報有無が選択されている場合だけリクエストパラメータに設定)
  if (additionalitem !== CONDITION_RADIO.CONDITION_FALSE
    && tradesearchflag2 && tradesearchflag2 !== CONDITION_RADIO.CONDITION_NONE) {
    param.trade_search_flag2 = tradesearchflag2;
    o.trade_search_flag2 = tradesearchflag2;
  }

  // 所在地リスト
  if (addressCondition && addressCondition.length > 0) {
    const locationList = [];
    const dispList = [];
    addressCondition.forEach((address) => {
      const record = {};
      if (address.area) {
        record.area = address.area;
      }
      if (address.prefectures) {
        record.prefectures = address.prefectures;
      }
      if (address.city_prefectures) {
        record.city_prefectures = address.city_prefectures;
      }
      if (address.city) {
        record.city = address.city;
      }
      locationList.push(record);

      // 画面表示用項目
      const dispRecord = {
        ...record,
        area_name: address.area_name,
        prefectures_name: address.prefectures_name,
        city_name: address.city_name,
      };
      dispList.push(dispRecord);
    });
    // リクエストパラメータ用
    param.location_list = locationList;
    // リストタブ表示用
    o.location_list = dispList;
  }
  // 業種リスト
  if (industryCondition && industryCondition.length > 0) {
    const industryList = [];
    const dispList = [];
    industryCondition.forEach((industry) => {
      const record = {};
      if (industry.major_classification) {
        record.major_classification = industry.major_classification;
      }
      if (industry.middle_classification) {
        record.middle_classification = industry.middle_classification;
      }
      if (industry.small_classification) {
        record.small_classification = industry.small_classification;
      }
      if (industry.fine_classification) {
        record.fine_classification = industry.fine_classification;
      }
      industryList.push(record);

      // 画面表示用項目
      const dispRecord = {
        ...record,
        major_name: industry.major_name,
        middle_name: industry.middle_name,
        small_name: industry.small_name,
        fine_name: industry.fine_name,
      };
      dispList.push(dispRecord);
    });
    // リクエストパラメータ用
    param.industry_list = industryList;
    // リストタブ表示用
    o.industry_list = dispList;
  }

  // 扱い品リスト
  if (productsCondition && productsCondition.length > 0) {
    const atsukaihinList = [];

    productsCondition.forEach((product) => {
      atsukaihinList.push(product.agcd);
    });
    // リクエストパラメータ用
    param.atsukaihin_list = atsukaihinList;
  }

  // 販売先リスト
  if (customerCompanyCondition && customerCompanyCondition.length > 0) {
    const customerCompanyList = [];

    customerCompanyCondition.forEach((customer) => {
      const values = Object.values(customer);
      customerCompanyList.push(values.join(''));
    });
    // リクエストパラメータ用
    param.hnbsk_list = customerCompanyList;
  }

  // 仕入先リスト
  if (supplierCompanyCondition && supplierCompanyCondition.length > 0) {
    const supplierCompanyList = [];

    supplierCompanyCondition.forEach((supplier) => {
      const values = Object.values(supplier);
      supplierCompanyList.push(values.join(''));
    });
    // リクエストパラメータ用
    param.srsk_list = supplierCompanyList;
  }

  // 国内最上位親会社リスト
  if (topCompanyCondition && topCompanyCondition.length > 0) {
    const topCompanyList = [];

    topCompanyCondition.forEach((top) => {
      const values = Object.values(top);
      topCompanyList.push(values.join(''));
    });
    // リクエストパラメータ用
    param.series_top_tsr_code_list = topCompanyList;
  }

  // 最新決算月
  if (accountMonth && accountMonth.length > 0) {
    const latestClosingMonth = accountMonth;

    // 決算月リストを数値の昇順にソート
    latestClosingMonth.sort((numberTarget1, numberTarget2) => numberTarget1 - numberTarget2);
    // リクエストパラメータ用
    param.closing_month = latestClosingMonth;
    // リストタブ表示用
    o.closing_month = latestClosingMonth;
  }

  // 事業所区分
  if (jgkbList && jgkbList.length > 0) {
    const targetJgkbList = jgkbList;

    // 事業所区分リストを業種コードの昇順にソート
    targetJgkbList.sort((numberTarget1, numberTarget2) => numberTarget1 - numberTarget2);
    // リクエストパラメータ用
    param.jgkb = targetJgkbList;
    // リストタブ表示用
    o.jgkb = targetJgkbList;
  }
  // 取引情報任意項目
  if (tradeInfoCondition && tradeInfoCondition.length > 0) {
    const tradeSearchList = [];
    const dispList = [];
    tradeInfoCondition.forEach((tradeInfo) => {
      const record = {};
      if (tradeInfo.item_code) {
        record.item_code = tradeInfo.item_code;
      }
      if (tradeInfo.item_value) {
        record.item_value = tradeInfo.item_value;
      }
      if (tradeInfo.search_type) {
        record.search_type = tradeInfo.search_type;
      }
      tradeSearchList.push(record);
      // 画面表示用項目
      const dispRecord = {
        ...record,
        item_code: tradeInfo.item_code,
        item_value: tradeInfo.item_value,
        search_type: tradeInfo.search_type,
      };
      dispList.push(dispRecord);
    });

    // リクエストパラメータ用
    param.trade_list = tradeSearchList;
    // リストタブ表示用
    o.trade_list = dispList;
  }

  if (additionalitem && additionalitem !== CONDITION_RADIO.CONDITION_NONE) {
    // 取引情報有無
    param.additional_item = additionalitem;
  }

  if (saveFlg !== '1') {
    // リクエストパラメータ用検索条件
    dispatch(setSearchCondition(param));
    // リストタブ表示用検索条件
    dispatch(setDispSearchCondition(o));
  } else {
    dispatch(setSaveCondition(param));
  }
  return true;
};

/**
 * 2.企業情報一覧の取得
 * @param   {number}  ページ番号
 * @returns {object}  企業情報一覧
 */
export const getCompanySearchList = (page) => async (dispatch, getState) => {
  const { searchCondition } = getState().target;

  // 検索条件
  const o = { ...searchCondition };

  // ページ番号
  o.page_no = page;

  // 取得上限
  o.limit_count = config.SEARCH_LIMIT_COUNT.TARGET;

  // 企業情報一覧検索（複数検索）APIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.GET_COMPANY_SEARCHLIST, o);

  // 取得件数0件の場合、一覧を空にする
  if (ret.result === RESULT_CODE.NOT_FOUND) {
    dispatch(setCompanySearchList());
    dispatch(setLimitMessage(null));
    return false;
  }
  // エラーの場合、メッセージを設定し一覧を空にする
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    dispatch(setCompanySearchList());
    dispatch(setLimitMessage(null));
    return false;
  }

  const allCount = ret.response && ret.response.all_count;
  // 全体件数が表示件数上限を超えている場合、エラーメッセージを表示する
  if (allCount && allCount > DISP_COUNT_LIMIT.TARGET) {
    dispatch(setLimitMessage(getMessage(WARN.W02001,
      Number(DISP_COUNT_LIMIT.TARGET).toLocaleString())));
  } else {
    dispatch(setLimitMessage(null));
  }
  dispatch(setCompanySearchList(ret.response));
  if (page == null) {
    dispatch(setNowpage(1));
  } else {
    dispatch(setNowpage(page));
  }

  // スクロールを先頭に戻す
  const ele = document.querySelector('.targetcompanylist .list');
  if (ele !== null) {
    ele.scrollTo(0, 0);
  }
  return true;
};

/**
 * CSVファイル作成リクエスト
 */
export const createDownloadFile = () => async (dispatch, getState) => {
  const {
    downloadConfig,
    searchCondition,
    downloadLimitOverFlg,
  } = getState().target;

  // 検索条件
  const o = { ...searchCondition };

  // 処理区分:ファイル作成
  o.process_type = CREATE_FILE_PROCESS_KBN.CREATE_FILE;

  if (downloadLimitOverFlg) {
    // 件数確認区分
    o.count_conf_type = '1';
  }

  // 検索対象
  o.download_value = downloadConfig;

  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.CREATE_COMPANY_OFFICE_FILE_MULTI, o);

  if (ret.result === RESULT_CODE.WARN) {
    // ダウンロード件数が超過件数を超えた場合、件数超過フラグとメッセージを設定
    dispatch(setDownloadRequestPopFlg(true, true, ret.response[0]));
  } else if (ret.result === RESULT_CODE.NOT_FOUND) {
    // 取得件数0件の場合、ダウンロードステータスを初期化
    dispatch(setDownloadStatus());
    dispatch(setDownloadRequestPopFlg(false));
  } else if (ret.result !== RESULT_CODE.SUCCESS) {
    // エラーの場合、メッセージ設定、ダウンロードステータスを初期化
    dispatch(setErrorMessage(ret.response));
    dispatch(setDownloadStatus());
    dispatch(setDownloadRequestPopFlg(false));
  } else {
    // 正常終了の場合、ダウンロードステータス情報を更新、ポーリング処理開始
    dispatch(setDownloadStatus(ret.response));
    dispatch(setDownloadRequestPopFlg(false));
    await dispatch(startDownloadPolling());
  }
};

/**
 * CSVファイルダウンロード
 */
export const fileDownloadExecute = () => async (dispatch, getState) => {
  const o = {};
  o.function_type = FUNC_TYPE.TARGET_DOWNLOAD;
  // API実行
  const ret = await requestApi(dispatch, API_END_POINT.UPDATE_EXCLUDE_FLG, o);
  // エラーが発生した場合
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    return false;
  }
  // ダウンロード処理
  const downLoadLink = document.createElement('a');
  document.body.appendChild(downLoadLink);
  downLoadLink.href = `${config.API_PROTOCOL}://${config.API_HOST}/${config.DOWNLOAD_PATH}/${getState().target.downloadStatus.file_name}`;
  downLoadLink.click();

  // ダウンロードステータスを初期化
  dispatch(setDownloadStatus());

  return true;
};

/**
 * お客様取引情報項目マスタ情報の取得
 * @param   {string}  divisionCode  分類コード
 * @returns {object}  お客様取引情報
 */
export const getTradeInfoMaster = (divisionCode) => async (dispatch) => {
  // リクエストパラメータ設定
  // リクエストパラメータ生成
  const o = {
    division_code: divisionCode,
  };
  // 住所マスタ取得APIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.GET_ADDITIONAL, o);
  // ネットワークエラーの場合
  if (ret.result === RESULT_CODE.ANOMALY) {
    dispatch(setErrorMessage(ERROR.E09013));
  }
  return ret.response;
};

/**
 * 業種キーワード検索
 * @param   {string}  divisionCode  分類コード
 * @returns {object}  お客様取引情報
 */
export const searchIndustryMaster = (
  selectIndustryB, selectIndustryN, selectIndustryS, industryKeyword,
) => async (dispatch) => {
  // リクエストパラメータ設定
  const o = {
    major_classification_code: selectIndustryB,
    middle_classification_code: selectIndustryN,
    small_classification_code: selectIndustryS,
    keyword: industryKeyword,
  };
  // 業種キーワード検索APIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.SEARCH_INDUSTRY, o);
  // ネットワークエラーの場合
  if (ret.result === RESULT_CODE.ANOMALY) {
    dispatch(setErrorMessage(ERROR.E09013));
  }
  return ret.response;
};

/**
 * 企業キーワード検索
 * @param   {string}  divisionCode  分類コード
 * @returns {object}  お客様取引情報
 */
export const searchCompany = (
  dunsKeyword, tsrKeyword, nameKeyword, hojinKeyword, companyNameSearchType, searchType,
) => async (dispatch) => {
  // リクエストパラメータ設定
  const o = {
    duns: dunsKeyword,
    tsr_code: tsrKeyword,
    company_name: nameKeyword,
    corporate_number: hojinKeyword,
    company_name_search_type: companyNameSearchType,
    search_type: searchType, // 1：ポップアップ一覧検索,2：保存条件反映時検索
  };
  // 企業情報検索APIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.SEARCH_COMPANY, o);
  if (ret.result !== RESULT_CODE.SUCCESS) {
    return null;
  }
  return ret.response;
};

/**
 * 検索条件保存
 * @param   {object}  saveCondition 検索条件
 * @param   {string}  conditionName 検索条件名
 * @returns boolean
 */
export const registerSearchCondition = () => async (dispatch, getState) => {
  const {
    saveCondition,
    conditionName,
  } = getState().target;

  // 検索条件
  const o = { ...saveCondition };

  // ページ番号
  o.page_no = null;

  // 取得上限
  o.limit_count = config.SEARCH_LIMIT_COUNT.TARGET;
  const param = { criteria_name: conditionName, criteria_json: JSON.stringify(o) };
  const ret = await requestApi(dispatch, API_END_POINT.CREATE_SEARCH_CONDITION, param);

  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrMsgConditionName(ret.response));
    return false;
  }
  return true;
};

/**
 * 検索条件一覧取得
 * @returns {object}  検索条件一覧
 */
export const getSearchConditionList = () => async (dispatch) => {
  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.GET_SEARCH_CONDITION_LIST);
  // エラーの場合はメッセージ設定
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrMsgSearchConditionPop(ret.response));
    return false;
  }
  // 検索結果のセット
  return ret.response;
};

/**
 * 検索条件インポート
 * @param   {object}  file ファイル
 */
export const importSearchCondition = (file) => async (dispatch) => {
  // リクエストパラメータ生成
  const f = new FormData();
  f.append('importFile', file);
  // データ更新ファイルアップロードAPIへリクエスト
  const xhr = await requestFileApi(dispatch, API_END_POINT.IMPORT_SEARCH_CONDITION);
  // レスポンスが正常の場合の処理
  xhr.oncsuccess = () => {
    if (xhr.status === 200) {
      dispatch(getSearchConditionList())
        .then(async (res) => {
          dispatch(setSearchConditionList(res.targeting_criteria_list));
        });
    }
  };
  xhr.oncerror = () => {
    const response = JSON.parse(xhr.response);
    dispatch(setErrorMessage());
    if (xhr.status === 500) {
      dispatch(setErrMsgSearchConditionPop(ERROR.E02006));
    } else {
      dispatch(setErrMsgSearchConditionPop(response.error_list[0]));
    }
  };
  xhr.send(f);
};

/**
 * 検索条件取得
 * @param   {string}  seqId シーケンスID
 * @returns {object}  検索条件
 */
export const getSearchCondition = (seqId) => async (dispatch) => {
  const o = {
    seq_id: seqId,
    check_master_flg: '1',
  };
  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.GET_SEARCH_CONDITION, o, false, false);
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrMsgSearchConditionPop(ret.response));
    return null;
  }
  return ret.response;
};

/**
 * 検索条件エクスポート
 * @param {string} seqId シーケンスID
 * @param {string} criteriaName 検索条件名
 * @param {string} checkMasterFlg マスタチェックフラグ
 * @returns boolean
 */
export const exportSearchCondition = (seqId, criteriaName, checkMasterFlg) => async (dispatch) => {
  // リクエストパラメータ生成
  const o = {
    seq_id: seqId,
    check_master_flg: checkMasterFlg,
  };
  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.GET_SEARCH_CONDITION, o, false, false);
  if (ret.result !== RESULT_CODE.SUCCESS) {
    // エラーが発生した場合、エラーメッセージを表示
    dispatch(setErrMsgSearchConditionPop(ret.response));
    return false;
  }

  // ファイル項目作成(検索条件名、検索条件JSON)
  const fileData = criteriaName + '\t'.concat(ret.response.criteria_json);
  const blob = new Blob([fileData], { type: 'text/plain' });
  // ファイルダウンロード
  const downLoadLink = document.createElement('a');
  document.body.appendChild(downLoadLink);
  downLoadLink.download = criteriaName.concat('.tsv');
  downLoadLink.href = window.URL.createObjectURL(blob);
  downLoadLink.click();

  return true;
};

/**
 * 検索条件削除
 * @param {string} seqId シーケンスID
 * @returns boolean
 */
export const deleteSearchCondition = (seqId) => async (dispatch) => {
  const param = {
    seq_id: seqId,
  };
  const ret = await requestApi(dispatch, API_END_POINT.DELETE_SEARCH_CONDITION, param);
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrMsgSearchConditionPop(ret.response));
    return false;
  }
  dispatch(getSearchConditionList())
    .then(async (res) => {
      dispatch(setSearchConditionList(res.targeting_criteria_list));
    });
  return true;
};

/**
 * 所在地取得（複数件）
 * @param   {object}  address 住所コード一覧
 * @returns {object}  所在地一覧
 */
export const getAddressMulti = (address) => async (dispatch) => {
  const param = {
    location_list: address,
  };
  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.GET_ADDRESS_MULTI, param);
  if (ret.result !== RESULT_CODE.SUCCESS) {
    return null;
  }
  return ret.response;
};

/**
 * 業種取得（複数件）
 * @param   {object}  industryList 業種コード一覧
 * @returns {object}  業種一覧
 */
export const getIndustryMulti = (industryList) => async (dispatch) => {
  const param = {
    industry_list: industryList,
  };
  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.GET_INDUSTRY_MULTI, param);
  if (ret.result !== RESULT_CODE.SUCCESS) {
    return null;
  }
  return ret.response;
};

/**
 * 扱い品取得（複数件）
 * @param   {object}  atsukaihinList 扱品コード一覧
 * @returns {object}  扱い品一覧
 */
export const getAtsukaihinMulti = (atsukaihinList) => async (dispatch) => {
  const param = {
    atsukaihin_list: atsukaihinList,
  };
  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.GET_ATSUKAIHIN_MULTI, param);
  if (ret.result !== RESULT_CODE.SUCCESS) {
    return null;
  }
  return ret.response;
};

/**
 * 検索タブ用検索条件設定
 * @param   {object}  targetingCriteria 検索条件
 * @returns boolean
 */
export const setDispCondition = (targetingCriteria) => (dispatch, getState) => {
  const {
    targetingDispItems,
  } = getState().target;

  const cond = {
    // 検索対象
    searchTarget: targetingCriteria.search_target,
  };
  // 主業種フラグ
  cond.mainIndustryFlg = targetingCriteria.shugyoshu_flg;
  // 売上高
  cond.salesFrom = targetingCriteria.sales_from ? targetingCriteria.sales_from : null;
  cond.salesTo = targetingCriteria.sales_to ? targetingCriteria.sales_to : null;
  // 資本金
  cond.capitalFrom = targetingCriteria.capital_from ? targetingCriteria.capital_from : null;
  cond.capitalTo = targetingCriteria.capital_to ? targetingCriteria.capital_to : null;
  // 売上高伸長率
  cond.salesRateFrom = targetingCriteria.sales_growth_rate_from
    ? targetingCriteria.sales_growth_rate_from : null;
  cond.salesRateTo = targetingCriteria.sales_growth_rate_to
    ? targetingCriteria.sales_growth_rate_to : null;
  // 利益金
  cond.benefitFrom = targetingCriteria.benefit_from ? targetingCriteria.benefit_from : null;
  cond.benefitTo = targetingCriteria.benefit_to ? targetingCriteria.benefit_to : null;
  // 利益金伸長率
  cond.benefitRateFrom = targetingCriteria.benefit_growth_rate_from
    ? targetingCriteria.benefit_growth_rate_from : null;
  cond.benefitRateTo = targetingCriteria.benefit_growth_rate_to
    ? targetingCriteria.benefit_growth_rate_to : null;
  // 従業員数
  cond.employeeFrom = targetingCriteria.employees_num_from
    ? targetingCriteria.employees_num_from : null;
  cond.employeeTo = targetingCriteria.employees_num_to
    ? targetingCriteria.employees_num_to : null;
  // 国内最上位親会社DUNS
  cond.topDuns = targetingCriteria.series_top_duns ? targetingCriteria.series_top_duns : null;
  // 国内最上位親会社TSRコード
  cond.topTsrCode = targetingCriteria.series_top_tsr_code
    ? targetingCriteria.series_top_tsr_code : null;
  // 事業所数
  cond.officeCountFrom = targetingCriteria.office_count_from
    ? targetingCriteria.office_count_from : null;
  cond.officeCountTo = targetingCriteria.office_count_to
    ? targetingCriteria.office_count_to : null;
  // 代表者
  cond.repLastName = targetingCriteria.rep_last_name ? targetingCriteria.rep_last_name : null;
  cond.repFirstName = targetingCriteria.rep_first_name ? targetingCriteria.rep_first_name : null;
  // 最新決済月
  cond.accountMonth = targetingCriteria.closing_month
    ? targetingCriteria.closing_month : [];
  // 取引情報有無
  cond.additionalitem = targetingCriteria.additional_item
    ? targetingCriteria.additional_item : CONDITION_RADIO.CONDITION_FALSE;
  // 取引情報検索フラグ1
  if (targetingCriteria.additional_item !== CONDITION_RADIO.CONDITION_FALSE
    && targetingCriteria.trade_search_flag1
    && targetingCriteria.trade_search_flag1 !== CONDITION_RADIO.CONDITION_NONE) {
    cond.tradesearchflag1 = targetingCriteria.trade_search_flag1;
  } else {
    cond.tradesearchflag1 = CONDITION_RADIO.CONDITION_NONE;
  }
  // 取引情報検索フラグ2
  if (targetingCriteria.additional_item !== CONDITION_RADIO.CONDITION_FALSE
    && targetingCriteria.trade_search_flag2
    && targetingCriteria.trade_search_flag2 !== CONDITION_RADIO.CONDITION_NONE) {
    cond.tradesearchflag2 = targetingCriteria.trade_search_flag2;
  } else {
    cond.tradesearchflag2 = CONDITION_RADIO.CONDITION_NONE;
  }
  // 表示用資本金(3桁カンマ)
  cond.dispCapitalFrom = targetingCriteria.capital_from ? targetingCriteria.capital_from : null;
  cond.dispCapitalTo = targetingCriteria.capital_to ? targetingCriteria.capital_to : null;
  // 表示用売上高(3桁カンマ)
  cond.dispSalesFrom = targetingCriteria.sales_from ? targetingCriteria.sales_from : null;
  cond.dispSalesTo = targetingCriteria.sales_to ? targetingCriteria.sales_to : null;
  // 表示用売上高伸長率(3桁カンマ)
  cond.dispSalesRateFrom = targetingCriteria.sales_growth_rate_from
    ? targetingCriteria.sales_growth_rate_from : null;
  cond.dispSalesRateTo = targetingCriteria.sales_growth_rate_to
    ? targetingCriteria.sales_growth_rate_to : null;
  // 表示用利益金(3桁カンマ)
  cond.dispBenefitFrom = targetingCriteria.benefit_from ? targetingCriteria.benefit_from : null;
  cond.dispBenefitTo = targetingCriteria.benefit_to ? targetingCriteria.benefit_to : null;
  // 表示用利益金伸長率(3桁カンマ)
  cond.dispBenefitRateFrom = targetingCriteria.benefit_growth_rate_from
    ? targetingCriteria.benefit_growth_rate_from : null;
  cond.dispBenefitRateTo = targetingCriteria.benefit_growth_rate_to
    ? targetingCriteria.benefit_growth_rate_to : null;
  // 表示用従業員数(3桁カンマ)
  cond.dispEmployeesFrom = targetingCriteria.employees_num_from
    ? targetingCriteria.employees_num_from : null;
  cond.dispEmployeesTo = targetingCriteria.employees_num_to
    ? targetingCriteria.employees_num_to : null;
  // 表示用事業所数(3桁カンマ)
  cond.dispOfficeCountFrom = targetingCriteria.office_count_from
    ? targetingCriteria.office_count_from : null;
  cond.dispOfficeCountTo = targetingCriteria.office_count_to
    ? targetingCriteria.office_count_to : null;

  // 商号漢字
  cond.sgkn = targetingCriteria.sgkn
    ? targetingCriteria.sgkn : null;
  // 商号漢字検索タイプ区分
  cond.sgknSearchType = targetingCriteria.sgkn_search_type
    ? targetingCriteria.sgkn_search_type : null;
  // 設立年月日
  cond.startYearFrom = targetingCriteria.strt_ym_from
    ? targetingCriteria.strt_ym_from.slice(0, 4) : null;
  cond.startMonthFrom = targetingCriteria.strt_ym_from
    ? targetingCriteria.strt_ym_from.slice(4, 6) : null;
  cond.startYearTo = targetingCriteria.strt_ym_to
    ? targetingCriteria.strt_ym_to.slice(0, 4) : null;
  cond.startMonthTo = targetingCriteria.strt_ym_to
    ? targetingCriteria.strt_ym_to.slice(4, 6) : null;
  // 上場市場
  cond.marketSegment = targetingCriteria.jjkb
    ? targetingCriteria.jjkb : [];
  // 決算情報最新期
  cond.latestFlg = targetingCriteria.latest_flg;
  // 国内最上位親会社
  if (targetingCriteria.series_top_tsr_code_list
    && targetingCriteria.series_top_tsr_code_list.length > 0) {
    const topCompanyList = [];

    targetingCriteria.series_top_tsr_code_list.forEach((top) => {
      topCompanyList.push(top);
    });
    // リクエストパラメータ用
    cond.series_top_tsr_code_list = topCompanyList;
  }

  // 所在地リスト
  if (targetingCriteria.location_list && targetingCriteria.location_list.length > 0) {
    const locationList = [];
    targetingCriteria.location_list.forEach((address) => {
      const record = {};
      if (address.area) {
        record.area = address.area;
      }
      if (address.prefectures) {
        record.prefectures = address.prefectures;
      }
      if (address.city_prefectures) {
        record.city_prefectures = address.city_prefectures;
      }
      if (address.city) {
        record.city = address.city;
      }
      locationList.push(record);
    });
    cond.addressCondition = locationList;
  } else {
    cond.addressCondition = [];
  }

  // 業種リスト
  if (targetingCriteria.industry_list && targetingCriteria.industry_list.length > 0) {
    const industryList = [];
    targetingCriteria.industry_list.forEach((industry) => {
      const record = {};
      if (industry.major_classification) {
        record.major_classification = industry.major_classification;
      }
      if (industry.middle_classification) {
        record.middle_classification = industry.middle_classification;
      }
      if (industry.small_classification) {
        record.small_classification = industry.small_classification;
      }
      if (industry.fine_classification) {
        record.fine_classification = industry.fine_classification;
      }
      industryList.push(record);
    });
    cond.industryCondition = industryList;
  } else {
    cond.industryCondition = [];
  }

  // 扱い品リスト
  if (targetingCriteria.atsukaihin_list && targetingCriteria.atsukaihin_list.length > 0) {
    const atsukaihinList = [];

    targetingCriteria.atsukaihin_list.forEach((product) => {
      atsukaihinList.push({ agcd: product });
    });
    cond.productsCondition = atsukaihinList;
  } else {
    cond.productsCondition = [];
  }

  // 取引情報任意項目
  if (targetingCriteria.trade_list && targetingCriteria.trade_list.length > 0) {
    const tradeSearchList = [];
    targetingCriteria.trade_list.forEach((tradeInfo) => {
      const record = {};
      if (tradeInfo.item_code) {
        record.item_code = tradeInfo.item_code;
      }
      if (tradeInfo.item_value) {
        record.item_value = tradeInfo.item_value;
      }
      if (tradeInfo.search_type) {
        record.search_type = tradeInfo.search_type;
      }
      tradeSearchList.push(record);
    });
    cond.tradeInfoCondition = tradeSearchList;
  } else {
    cond.tradeInfoCondition = [];
  }

  // 以下項目はターゲティング画面項目マスタに存在する項目を設定
  // 評点
  cond.scoreFrom = null;
  cond.scoreTo = null;
  // 概況
  cond.syrkGkny = null;
  // 格付け
  cond.classificationList = [];
  // 販売先
  cond.hnbsk_list = [];
  // 仕入先
  cond.srsk_list = [];
  // 事業所区分
  cond.jgkbList = [];

  if (targetingDispItems) {
    targetingDispItems.search_option_list.forEach((label) => {
      switch (label.item_name) {
        case TARGET_SEARCH_DISP_ITEM.HYOTEN:
          cond.scoreFrom = targetingCriteria.score_from
            ? targetingCriteria.score_from : null;
          cond.scoreTo = targetingCriteria.score_to
            ? targetingCriteria.score_to : null;
          break;
        case TARGET_SEARCH_DISP_ITEM.GAIKYO:
          cond.syrkGkny = targetingCriteria.syrk_gkny
            ? targetingCriteria.syrk_gkny : null;
          break;
        case TARGET_SEARCH_DISP_ITEM.KAKUDUKE:
          cond.classificationList = targetingCriteria.tsr_kdkb_list
            ? targetingCriteria.tsr_kdkb_list : [];
          break;
        case TARGET_SEARCH_DISP_ITEM.HANBAISAKI:
          if (targetingCriteria.hnbsk_list && targetingCriteria.hnbsk_list.length > 0) {
            const customerCompanyList = [];

            targetingCriteria.hnbsk_list.forEach((customer) => {
              customerCompanyList.push(customer);
            });
            // リクエストパラメータ用
            cond.hnbsk_list = customerCompanyList;
          }
          break;
        case TARGET_SEARCH_DISP_ITEM.SIRESAKI:
          if (targetingCriteria.srsk_list && targetingCriteria.srsk_list.length > 0) {
            const supplierCompanyList = [];

            targetingCriteria.srsk_list.forEach((supplier) => {
              supplierCompanyList.push(supplier);
            });
            // リクエストパラメータ用
            cond.srsk_list = supplierCompanyList;
          }
          break;
        case TARGET_SEARCH_DISP_ITEM.JIGYOSYOKBN:
          cond.jgkbList = targetingCriteria.jgkb
            ? targetingCriteria.jgkb : [];
          break;
        default:
          break;
      }
    });
  }

  dispatch(setUpdateTargetingCriteria(cond));

  return true;
};

/**
 * ターゲティング画面項目マスタ取得
 * @returns {object}  ターゲティング画面項目一覧
 */
export const getTargetingDispItemList = () => async (dispatch) => {
  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.GET_TARGETING_DISP_ITEMS);
  if (ret.result !== RESULT_CODE.SUCCESS) {
    return null;
  }
  // 検索結果のセット
  return ret.response;
};

/**
 * 所在地キーワード検索
 * @param   {string}  selectArea  地域コード
 * @param   {string}  selectPref  都道府県コード
 * @param   {string}  addressKeyword  キーワード
 * @returns {object}  所在地リスト
 */
export const searchAddress = (
  selectArea, selectPref, addressKeyword,
) => async (dispatch) => {
  // リクエストパラメータ設定
  const o = {
    area_code: selectArea,
    prefectures_code: selectPref,
    keyword: addressKeyword,
  };
  // 所在地キーワード検索APIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.SEARCH_ADDRESS, o);
  if (ret.result !== RESULT_CODE.SUCCESS) {
    return null;
  }
  return ret.response;
};

/**
 * ターゲティング外部連携ファイル作成
 */
export const createExternalFile = (sendType) => async (dispatch, getState) => {
  const {
    searchCondition,
    sendSalesforceTargetName,
    sendExternalTargetName,
    sendExternalConfig,
    companySearchList,
  } = getState().target;

  // 検索条件
  const o = { ...searchCondition };

  // 送信区分
  o.send_type = sendType;

  // 送信区分による値設定
  if (sendType === SEND_TYPE.EXTERNAL) {
    // ダウンロード項目(送信区分が2:API外部連携の場合必須)
    o.download_value = sendExternalConfig;
    // ターゲティング名称
    o.targeting_name = sendExternalTargetName;
  } else if (sendType === SEND_TYPE.SALESFORCE) {
    // ターゲティング名称
    o.targeting_name = sendSalesforceTargetName;
  }
  // データ件数
  o.data_count = companySearchList.all_count;

  // 外部連携実行
  const ret = await requestApi(dispatch, API_END_POINT.CREATE_COMPANY_OFFICE_FILE_EXTERNAL, o);

  if (ret.result === RESULT_CODE.NOT_FOUND) {
    // 取得0件の場合、メッセージ設定、画面閉じる
    dispatch(setExternalErrMsg(ret.response));
    dispatch(setSendExternalResultPopFlg(false));
    dispatch(setSendSalesforcePopFlg(false));
    dispatch(setSendExternalPopFlg(false));
  } else if (ret.result !== RESULT_CODE.SUCCESS) {
    // エラーの場合、メッセージ設定
    dispatch(setExternalErrMsg(ret.response));
  } else {
    // 正常終了時、結果画面を表示する
    dispatch(setSendExternalResultPopFlg(true));
  }

  return ret.response;
};

/**
 * Salesforce連携マッピング取得
 */
export const getMapping = () => async (dispatch) => {
  // Salesforce連携マッピング取得
  const ret = await requestApi(dispatch, API_END_POINT.GET_MAPPING);

  if (ret.result !== RESULT_CODE.SUCCESS) {
    // エラーの場合、メッセージ設定、画面閉じる
    dispatch(setErrorMessage(ret.response));
    dispatch(setSendSalesforcePopFlg(false));
    dispatch(setSendExternalPopFlg(false));

    return null;
  }

  return ret.response;
};

/**
 * 外部連携情報取得
 */
export const getExternalInfo = () => async (dispatch) => {
  // 外部連携情報取得
  const ret = await requestApi(dispatch, API_END_POINT.GET_EXTERNAL_INFO);

  if (ret.result !== RESULT_CODE.SUCCESS) {
    // エラーの場合、メッセージ設定、画面閉じる
    dispatch(setErrorMessage(ret.response));
    dispatch(setSendSalesforcePopFlg(false));
    dispatch(setSendExternalPopFlg(false));

    return null;
  }

  return ret.response;
};
